import { useContext, useEffect, useState } from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { Stack, StackItem } from "@fluentui/react/lib/Stack";
import {
  Breadcrumb,
  Checkbox,
  ComboBox,
  FontSizes,
  FontWeights,
  IBreadcrumbItem,
  IComboBoxStyles,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Separator,
} from "@fluentui/react";
import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import "../../CustomerAccount/CustomerAccountStyle.css";
import {
  TextFieldStyles,
  TextGrayFieldStyles,
  EditComboBoxStyles,
  SaveAndNextButtonStyleShipping,
  CheckBoxStyle,
} from "../CustomerStyle";
import {
  ICustomerAccountsProps,
  CustomerAccountInfoType,
  CustomerLocationState,
  ResponseCustomerEditAccount,
} from "../Customer.types";
import {
  BILLING_ADDRESS,
  CustomerContext,
  FAPIAO_ADDRESS,
  REGISTERED_ADDRESS,
  Shipping_ADDRESS,
  intialCustomerInfo,
} from "../CustomerContext";
import {
  typeAffilationOptions,
  paymentTermsOptions,
  countryWiseStateList,
  businessEducationAffiliation,
  customerAddressSetup as customer,
} from "../CustomerFormInitialValues";
import {
  AUTHORIZED_BUYER_EMAIL_REQUIRED,
  AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
  AUTHORIZED_BUYER_LASTNAME_REQUIRED,
  AUTHORIZED_BUYER_PHONE_REQUIRED,
  BILLINGNAME_REQUIRED,
  BILLING_NAME_CHARACTER_LIMIT,
  CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
  CITY_CHARACTER_LIMIT,
  CITY_REQUIRED,
  COMPANY_TAXID_CHARACTER_LIMIT,
  CONTACT_FIRSTNAME_CHARACTER_LIMIT,
  CONTACT_LASTNAME_CHARACTER_LIMIT,
  COUNTRY_REQUIRED,
  CUSTOMER_NAME_CHARACTER_LIMIT,
  CUSTOMER_NAME_REQUIRED,
  EMAIL_CHARACTER_LIMIT,
  EMAIL_VALIDATION,
  INVALID_PHONENUMBER,
  LEADACCOUNT_ID_REQUIRED,
  NUMBERS_ALLOWED,
  POSTALCODE_CHARACTER_LIMIT,
  POSTALCODE_REQUIRED,
  PROVINCE_REQUIRED,
  SHIPPING_NAME_CHARACTER_LIMIT,
  SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
  SPECIAL_CHARACTERS_NOT_ALLOWED,
  SPECIL_CHARACTER_INVALID_PHONENUMBER,
  STREET_REQUIRED,
  Street_PO_BOX_VALIDATION,
  allowCharactersAndSpecialSymbols,
  allowSpecialCharacterExcludingSome,
  cityCharacterLimit,
  companyNameCharacterLimit,
  companyTaxIdCharacterLimit,
  contactNameCharacterLimit,
  contactNumberRegex,
  CUSTOMER_CERTIFIED_EMAIL_REQUIRED,
  emailCharacterLimit,
  emailRegex,
  numbersOnly,
  phoneNumberRegex,
  poBoxRegex,
  postalCodeCharacterLimit,
  uiNAPattern,
  validateCompleteAddCustomerAccountFields,
} from "./AddCustomerValidation";
import { CustomerService } from "../../../services/Customers/CustomerService";
import { stackTokensWithGap10 } from "../../Quotation/QuotationStyle";
import {
  BreadcrumbStyle,
  LoadingContainerStyle,
} from "../../Quotation/AddQuotation/AddQuotationStyle";
import {
  Card,
  CardStandardHeader,
  LoadingState,
} from "@coherence-design-system/controls";
import {
  InitialStateOfResponseMessage,
  STATE_REQUIRED,
} from "../../CountriesProfile/CountriesProfileValidation";
import { appInsights } from "../../../services/Logging/AppInsights";
import { IResponseMessage } from "../../Quotation/Quotation.types";
import { useLocalStorageContext } from "../../../Provider/LocalStorageProvider";
import { CommonService } from "../../../services/Common/CommonService";
export const intialCustomerErrorValue = {
  accountId: "",
  id: "",
  taxId: "",
  sapAccountId: "",
  legalAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  paymentTerms: "",
  country: "",
  customerRegion: "",
  registerAddress: {
    addressId: "",
    affilation: REGISTERED_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "No",
    },
    state: "",
    isAddressPrimary: "",
    sapAccountId: "",
  },
  billingAddress: {
    addressId: "",
    affilation: BILLING_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "No",
    },
    state: "",
    isAddressPrimary: "",
    sapAccountId: "",
  },
  shippingAddress: {
    addressId: "",
    affilation: Shipping_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "No",
    },
    state: "",
    isAddressPrimary: "",
    sapAccountId: "",
  },
  fapiaoAddress: {
    addressId: "",
    affilation: FAPIAO_ADDRESS,
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: " ",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "No",
    },
    state: "",
    isAddressPrimary: "",
  },
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};
const countryIntialValue = [
  {
    key: "",
    text: "",
    region: "",
  },
];
export const useScreenScale = () => {
  const [screenScale, setScreenScale] = useState(window.devicePixelRatio);
  useEffect(() => {
    const handleResize = () => {
      setScreenScale(window.devicePixelRatio);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return screenScale;
};
export const validateMsxOppertunityIdCheck = (
  value: string | undefined,
  setMsxIdError: (customerError: any) => void,
  setMsxIdExist: (isMsdExist: any) => void
) => {
  setMsxIdExist(false);
  CustomerService.validateMsxOpportunityId(value!)
    .then((res) => {
      if (res?.data?.code === 200 && res?.data?.data) {
        setMsxIdError("");
        setMsxIdExist(true);
      } else {
        setMsxIdError("MSX Account ID is invalid");
        setMsxIdExist(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setMsxIdError("MSX Account ID is invalid");
    });
};
export const validateCustomerTaxIdCheck = (
  value: string | undefined,
  setTaxIdError: (customerAccountError: any) => void,
  setTaxIdExist: (isTaxIdExist: any) => void
) => {
  CustomerService.validateCustomerTaxId(value!)
    .then((res) => {
      if (res?.data?.code === 200 && res?.data?.data) {
        setTaxIdError("Tax ID already exist");
        setTaxIdExist(true);
      } else {
        setTaxIdError("");
        setTaxIdExist(false);
      }
    })
    .catch((error) => {
      console.log(error);
      setTaxIdError("Tax ID is invalid");
    });
};
export const CustomerNewAccount: React.FunctionComponent<
  ICustomerAccountsProps
> = (props) => {
  const { customerAccountInfo, setCustomerAccountInfo } = useContext(
    CustomerContext
  ) as CustomerAccountInfoType;
  const navigate = useNavigate();
  const location = useLocation().state as CustomerLocationState;
  const [customerAccountError, setCustomerAccountError] = useState(
    intialCustomerErrorValue
  );
  const [taxIdExist, setTaxIdExist] = useState(false);
  const [msxIdExist, setMsxIdExist] = useState(true);
  const [msxIdError, setMsxIdError] = useState("");
  const [taxIdError, setTaxIdError] = useState("");
  const screenScale = useScreenScale();
  let cardSize = { width: "725px", paddingLeft: "80px", paddingTop: "10px" };
  const [customerSuccessMessage, setCustomerSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [customerFailureMessage, setCustomerFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const { userRegions } = useLocalStorageContext();
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [isBillingChecked, setIsBillingChecked] = useState(false);
  const [isBillingContactChecked, setIsBillingContactChecked] = useState(false);
  const [billingDetailsHeight, setBillingDetailsHeight] = useState("600px");
  const [isShippingChecked, setIsShippingChecked] = useState(false);
  const [isShippingContactChecked, setIsShippingContactChecked] =
    useState(false);
  const [
    isShippingByBusinessAddressChecked,
    setIsShippingByBusinessAddressChecked,
  ] = useState(false);
  const [
    isShippingByBusinessContactChecked,
    setIsShippingByBusinessContactChecked,
  ] = useState(false);
  const [isFapiaoChecked, setIsFapiaoChecked] = useState(false);
  const [isfapiaoContactChecked, setIsFapiaoContactChecked] = useState(false);
  const [countryOptions, setCountryOptions] = useState(countryIntialValue);
  const [loader, setLoader] = useState({ isLoading: false, message: "" });
  const customerNewAccountComboBoxStyle = {
    root: { width: 290 },
    callout: { width: "300px", height: "290px" },
  };
  const customerNewAccountComboBoxStyleAuto = {
    root: { width: 290 },
    callout: { width: "300px" },
  };
  const [registeredAddressStateOptions, setRegisteredAddressStateOptions] =
    useState([{ key: "", text: "", country: "" }]);
  const [billingAddressStateOptions, setBillingAddressStateOptions] = useState([
    { key: "", text: "", country: "" },
  ]);
  const [fapioAddressStateOptions, setFapioAddressStateOptions] = useState([
    { key: "", text: "", country: "" },
  ]);
  const [shippingAddressStateOptions, setShippingAddressStateOptions] =
    useState([{ key: "", text: "", country: "" }]);
  const getBreadcrumbItems = () => {
    const items: IBreadcrumbItem[] = [
      {
        text: "Customers",
        key: "Customers",
        onClick: () => {
          navigate("/Customer");
        },
      },
      { text: `New Account`, key: `New Account` },
    ];
    return items;
  };
  useEffect(() => {
    setLoader({
      isLoading: true,
      message: "Loading...",
    });
    CustomerService.getMSEFriendlyCustomerAccountNumber()
      .then((res) => {
        if (res.status === 200 && res.data != undefined) {
          setCustomerAccountInfo({
            ...intialCustomerInfo,
            accountId: res?.data?.data,
          });
          setLoader({
            isLoading: false,
            message: "",
          });
          appInsights.trackEvent({
            name: "In CustomerNewAccount.tsx, revieved the accountId successfully",
          });
        } else {
          setCustomerAccountError({
            ...customerAccountError,
            accountId: "Unable to Create a customer account",
          });
          setLoader({
            isLoading: false,
            message: "",
          });
          appInsights.trackEvent({
            name: "In CustomerNewAccount.tsx, recieved accountId is null",
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          error: new Error(error as string),
          properties: {
            name: "Error in fetching customer account ID api in CustomerNewAccount.tsx",
          },
        });
        setLoader({
          isLoading: false,
          message: "",
        });
      });
  }, []);
  const [
    CustomerCertifiedEmailAndConsigneedCodeCountries,
    setCustomerCertifiedEmailAndConsigneedCodeCountries,
  ] = useState<string[]>([]);
  useEffect(() => {
    setCustomerAccountError(intialCustomerErrorValue);
    CommonService.populateCountriesDetails()
      .then((res) => {
        if (res !== undefined) {
          setCountryOptions(res?.data?.data);
        } else {
          setCustomerFailureMessage({
            message: `Error with country data`,
            showMessage: true,
          });
          setIsSaveButtonDisabled(true);
        }
      })
      .catch((error) => {
        console.log(
          "Error in getCustomerAccountsInfoById CustomerAddAddress.tsx" + error
        );
      });
  }, []);
  useEffect(() => {
    const countries = countryOptions
      .filter(
        (item) =>
          item.region === "EMEA" ||
          item.region === "APAC" ||
          item.region == "Japan"
      )
      .map((x) => x.text);
    setCustomerCertifiedEmailAndConsigneedCodeCountries(countries);
  }, [JSON.stringify(countryOptions)]);
  const comboBoxStyles: Partial<IComboBoxStyles> = {
    root: {
      width: 200,
    },
  };
  function createErrorList(errorObject: any) {
    const errorList = [];
    for (const key in errorObject) {
      if (errorObject.hasOwnProperty(key)) {
        const subErrors = errorObject[key];
        if (typeof subErrors === "object") {
          const nestedErrors: any = createErrorList(subErrors);
          errorList.push(
            ...nestedErrors.map((error: any) => `${key}.${error}`)
          );
        } else {
          errorList.push(`${key}: ${errorObject[key]}`);
        }
      }
    }
    return errorList;
  }
  const completeCustomerErrorList = createErrorList(customerAccountError);
  const registeredAddressErrorList = createErrorList(
    customerAccountError.registerAddress
  );
  const billingAddressErrorList = createErrorList(
    customerAccountError.billingAddress
  );
  const billingContactsErrorList = createErrorList(
    customerAccountError.billingAddress.contacts
  );
  const shippingAddressErrorList = createErrorList(
    customerAccountError.shippingAddress
  );
  const shippingContactsErrorList = createErrorList(
    customerAccountError.shippingAddress.contacts
  );
  const fapiaoAddressErrorList = createErrorList(
    customerAccountError.fapiaoAddress
  );
  const fapiaoContactsErrorList = createErrorList(
    customerAccountError.fapiaoAddress.contacts
  );
  const billingErrorMessages = Object.entries(billingAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const billingContactsErrorMessages = Object.entries(billingContactsErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const shippingErrorMessages = Object.entries(shippingAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const shippingContactsErrorMessages = Object.entries(
    shippingContactsErrorList
  )
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const fapiaoErrorMessages = Object.entries(fapiaoAddressErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const fapiaoContactsErrorMessages = Object.entries(fapiaoContactsErrorList)
    .filter(([key, value]) => value.trim().toLowerCase().includes("required"))
    .map(([key, value]) => `${key}: ${value}`);
  const [certifiedEmailAndConsigneeCode, setCertifiedEmailAndConsigneeCode] =
    useState(false);
  useEffect(() => {
    if (
      CustomerCertifiedEmailAndConsigneedCodeCountries.includes(
        customerAccountInfo.registerAddress.country
      )
    ) {
      setCertifiedEmailAndConsigneeCode(true);
    } else {
      setCertifiedEmailAndConsigneeCode(false);
    }
  }, [customerAccountInfo.registerAddress.country]);
  const anyToggleError =
    billingErrorMessages.length > 0 ||
    billingContactsErrorMessages.length > 0 ||
    shippingErrorMessages.length > 0 ||
    shippingContactsErrorMessages.length > 0;

  // Function to check if billing address fields are complete and clear required errors
  const checkAndClearBillingErrors = () => {
    if (isBillingChecked) {
      const billingFieldsComplete =
        customerAccountInfo.billingAddress.name.trim() !== "" &&
        customerAccountInfo.billingAddress.street.trim() !== "" &&
        customerAccountInfo.billingAddress.postalCode.trim() !== "" &&
        customerAccountInfo.billingAddress.city.trim() !== "" &&
        customerAccountInfo.billingAddress.state.trim() !== "" &&
        customerAccountInfo.billingAddress.country.trim() !== "";

      if (billingFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          billingAddress: {
            ...prev.billingAddress,
            name:
              prev.billingAddress.name === CUSTOMER_NAME_REQUIRED
                ? ""
                : prev.billingAddress.name,
            street:
              prev.billingAddress.street === STREET_REQUIRED
                ? ""
                : prev.billingAddress.street,
            postalCode:
              prev.billingAddress.postalCode === POSTALCODE_REQUIRED
                ? ""
                : prev.billingAddress.postalCode,
            city:
              prev.billingAddress.city === CITY_REQUIRED
                ? ""
                : prev.billingAddress.city,
            state:
              prev.billingAddress.state === PROVINCE_REQUIRED
                ? ""
                : prev.billingAddress.state,
            country:
              prev.billingAddress.country === COUNTRY_REQUIRED
                ? ""
                : prev.billingAddress.country,
          },
        }));
      }
    }
  };

  // Function to check if billing contact fields are complete and clear required errors
  const checkAndClearBillingContactErrors = () => {
    if (isBillingContactChecked) {
      const billingContactFieldsComplete =
        customerAccountInfo.billingAddress?.contacts?.contactFirstName?.trim() !==
          "" &&
        customerAccountInfo.billingAddress?.contacts?.contactLastName?.trim() !==
          "" &&
        customerAccountInfo.billingAddress?.contacts?.contactPhone?.trim() !==
          "" &&
        customerAccountInfo.billingAddress?.contacts?.contactEmail?.trim() !==
          "";

      if (billingContactFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          billingAddress: {
            ...prev.billingAddress,
            contacts: {
              ...prev.billingAddress.contacts,
              contactFirstName:
                prev.billingAddress.contacts.contactFirstName ===
                AUTHORIZED_BUYER_FIRSTNAME_REQUIRED
                  ? ""
                  : prev.billingAddress.contacts.contactFirstName,
              contactLastName:
                prev.billingAddress.contacts.contactLastName ===
                AUTHORIZED_BUYER_LASTNAME_REQUIRED
                  ? ""
                  : prev.billingAddress.contacts.contactLastName,
              contactPhone:
                prev.billingAddress.contacts.contactPhone ===
                AUTHORIZED_BUYER_PHONE_REQUIRED
                  ? ""
                  : prev.billingAddress.contacts.contactPhone,
              contactEmail:
                prev.billingAddress.contacts.contactEmail ===
                AUTHORIZED_BUYER_EMAIL_REQUIRED
                  ? ""
                  : prev.billingAddress.contacts.contactEmail,
            },
          },
        }));
      }
    }
  };

  // Function to check if shipping address fields are complete and clear required errors
  const checkAndClearShippingErrors = () => {
    if (isShippingChecked || isShippingByBusinessAddressChecked) {
      const shippingFieldsComplete =
        customerAccountInfo.shippingAddress.name.trim() !== "" &&
        customerAccountInfo.shippingAddress.street.trim() !== "" &&
        customerAccountInfo.shippingAddress.postalCode.trim() !== "" &&
        customerAccountInfo.shippingAddress.city.trim() !== "" &&
        customerAccountInfo.shippingAddress.state.trim() !== "" &&
        customerAccountInfo.shippingAddress.country.trim() !== "";

      if (shippingFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          shippingAddress: {
            ...prev.shippingAddress,
            name:
              prev.shippingAddress.name === CUSTOMER_NAME_REQUIRED
                ? ""
                : prev.shippingAddress.name,
            street:
              prev.shippingAddress.street === STREET_REQUIRED
                ? ""
                : prev.shippingAddress.street,
            postalCode:
              prev.shippingAddress.postalCode === POSTALCODE_REQUIRED
                ? ""
                : prev.shippingAddress.postalCode,
            city:
              prev.shippingAddress.city === CITY_REQUIRED
                ? ""
                : prev.shippingAddress.city,
            state:
              prev.shippingAddress.state === PROVINCE_REQUIRED
                ? ""
                : prev.shippingAddress.state,
            country:
              prev.shippingAddress.country === COUNTRY_REQUIRED
                ? ""
                : prev.shippingAddress.country,
          },
        }));
      }
    }
  };

  // Function to check if shipping contact fields are complete and clear required errors
  const checkAndClearShippingContactErrors = () => {
    if (isShippingContactChecked || isShippingByBusinessContactChecked) {
      const shippingContactFieldsComplete =
        customerAccountInfo.shippingAddress?.contacts?.contactFirstName?.trim() !==
          "" &&
        customerAccountInfo.shippingAddress?.contacts?.contactLastName?.trim() !==
          "" &&
        customerAccountInfo.shippingAddress?.contacts?.contactPhone?.trim() !==
          "" &&
        customerAccountInfo.shippingAddress?.contacts?.contactEmail?.trim() !==
          "";

      if (shippingContactFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          shippingAddress: {
            ...prev.shippingAddress,
            contacts: {
              ...prev.shippingAddress.contacts,
              contactFirstName:
                prev.shippingAddress?.contacts?.contactFirstName ===
                AUTHORIZED_BUYER_FIRSTNAME_REQUIRED
                  ? ""
                  : prev.shippingAddress?.contacts?.contactFirstName || "",
              contactLastName:
                prev.shippingAddress?.contacts?.contactLastName ===
                AUTHORIZED_BUYER_LASTNAME_REQUIRED
                  ? ""
                  : prev.shippingAddress?.contacts?.contactLastName || "",
              contactPhone:
                prev.shippingAddress?.contacts?.contactPhone ===
                AUTHORIZED_BUYER_PHONE_REQUIRED
                  ? ""
                  : prev.shippingAddress?.contacts?.contactPhone || "",
              contactEmail:
                prev.shippingAddress?.contacts?.contactEmail ===
                AUTHORIZED_BUYER_EMAIL_REQUIRED
                  ? ""
                  : prev.shippingAddress?.contacts?.contactEmail || "",
            },
          },
        }));
      }
    }
  };

  // Function to check if fapiao address fields are complete and clear required errors
  const checkAndClearFapiaoErrors = () => {
    if (
      isFapiaoChecked &&
      customerAccountInfo.billingAddress.country.toLocaleUpperCase() === "CHINA"
    ) {
      const fapiaoFieldsComplete =
        customerAccountInfo.fapiaoAddress.name.trim() !== "" &&
        customerAccountInfo.fapiaoAddress.street.trim() !== "" &&
        customerAccountInfo.fapiaoAddress.postalCode.trim() !== "" &&
        customerAccountInfo.fapiaoAddress.city.trim() !== "" &&
        customerAccountInfo.fapiaoAddress.state.trim() !== "" &&
        customerAccountInfo.fapiaoAddress.country.trim() !== "";

      if (fapiaoFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          fapiaoAddress: {
            ...prev.fapiaoAddress,
            name:
              prev.fapiaoAddress.name === CUSTOMER_NAME_REQUIRED
                ? ""
                : prev.fapiaoAddress.name,
            street:
              prev.fapiaoAddress.street === STREET_REQUIRED
                ? ""
                : prev.fapiaoAddress.street,
            postalCode:
              prev.fapiaoAddress.postalCode === POSTALCODE_REQUIRED
                ? ""
                : prev.fapiaoAddress.postalCode,
            city:
              prev.fapiaoAddress.city === CITY_REQUIRED
                ? ""
                : prev.fapiaoAddress.city,
            state:
              prev.fapiaoAddress.state === PROVINCE_REQUIRED
                ? ""
                : prev.fapiaoAddress.state,
            country:
              prev.fapiaoAddress.country === COUNTRY_REQUIRED
                ? ""
                : prev.fapiaoAddress.country,
          },
        }));
      }
    }
  };

  // Function to check if fapiao contact fields are complete and clear required errors
  const checkAndClearFapiaoContactErrors = () => {
    if (isfapiaoContactChecked) {
      const fapiaoContactFieldsComplete =
        customerAccountInfo.fapiaoAddress?.contacts?.contactFirstName?.trim() !==
          "" &&
        customerAccountInfo.fapiaoAddress?.contacts?.contactLastName?.trim() !==
          "" &&
        customerAccountInfo.fapiaoAddress?.contacts?.contactPhone?.trim() !==
          "" &&
        customerAccountInfo.fapiaoAddress?.contacts?.contactEmail?.trim() !==
          "";

      if (fapiaoContactFieldsComplete) {
        setCustomerAccountError((prev) => ({
          ...prev,
          fapiaoAddress: {
            ...prev.fapiaoAddress,
            contacts: {
              ...prev.fapiaoAddress.contacts,
              contactFirstName:
                prev.fapiaoAddress?.contacts?.contactFirstName ===
                AUTHORIZED_BUYER_FIRSTNAME_REQUIRED
                  ? ""
                  : prev.fapiaoAddress?.contacts?.contactFirstName || "",
              contactLastName:
                prev.fapiaoAddress?.contacts?.contactLastName ===
                AUTHORIZED_BUYER_LASTNAME_REQUIRED
                  ? ""
                  : prev.fapiaoAddress?.contacts?.contactLastName || "",
              contactPhone:
                prev.fapiaoAddress?.contacts?.contactPhone ===
                AUTHORIZED_BUYER_PHONE_REQUIRED
                  ? ""
                  : prev.fapiaoAddress?.contacts?.contactPhone || "",
              contactEmail:
                prev.fapiaoAddress?.contacts?.contactEmail ===
                AUTHORIZED_BUYER_EMAIL_REQUIRED
                  ? ""
                  : prev.fapiaoAddress?.contacts?.contactEmail || "",
            },
          },
        }));
      }
    }
  };

  // Function to check if main contact/authorized buyer fields are complete and clear required errors
  const checkAndClearMainContactErrors = () => {
    const mainContactFieldsComplete =
      customerAccountInfo.authorizedBuyerFirstName?.trim() !== "" &&
      customerAccountInfo.authorizedBuyerLastName?.trim() !== "" &&
      customerAccountInfo.authorizedBuyerPhone?.trim() !== "" &&
      customerAccountInfo.authorizedEmailId?.trim() !== "";

    if (mainContactFieldsComplete) {
      setCustomerAccountError((prev) => ({
        ...prev,
        authorizedBuyerFirstName:
          prev.authorizedBuyerFirstName === AUTHORIZED_BUYER_FIRSTNAME_REQUIRED
            ? ""
            : prev.authorizedBuyerFirstName,
        authorizedBuyerLastName:
          prev.authorizedBuyerLastName === AUTHORIZED_BUYER_LASTNAME_REQUIRED
            ? ""
            : prev.authorizedBuyerLastName,
        authorizedBuyerPhone:
          prev.authorizedBuyerPhone === AUTHORIZED_BUYER_PHONE_REQUIRED
            ? ""
            : prev.authorizedBuyerPhone,
        authorizedEmailId:
          prev.authorizedEmailId === AUTHORIZED_BUYER_EMAIL_REQUIRED
            ? ""
            : prev.authorizedEmailId,
      }));
    }
  };

  // Auto-clear "Required Fields are missing" messages when sections are complete
  useEffect(() => {
    checkAndClearBillingErrors();
    checkAndClearBillingContactErrors();
    checkAndClearShippingErrors();
    checkAndClearShippingContactErrors();
    checkAndClearFapiaoErrors();
    checkAndClearFapiaoContactErrors();
    checkAndClearMainContactErrors();
  }, [
    customerAccountInfo,
    isBillingChecked,
    isBillingContactChecked,
    isShippingChecked,
    isShippingContactChecked,
    isShippingByBusinessAddressChecked,
    isShippingByBusinessContactChecked,
    isFapiaoChecked,
    isfapiaoContactChecked,
  ]);

  const handleAddCustomerClick = async () => {
    setLoader({
      isLoading: true,
      message: "Creating customer account",
    });
    setCustomerAccountError(intialCustomerErrorValue);
    const customerRegion = countryOptions?.find(
      (x) => x.text === customerAccountInfo.registerAddress.country
    )?.region;
    const { isValidated, customerAccountErrors } =
      validateCompleteAddCustomerAccountFields(customerAccountInfo);
    if (isValidated && !taxIdExist && msxIdExist && !anyToggleError) {
      let couponCode: string[] = [];
      if (
        customerAccountInfo.affilation === businessEducationAffiliation.text
      ) {
        couponCode.push(businessEducationAffiliation.key);
      }
      setIsSaveButtonDisabled(true);
      let validateObject = new Object() as ResponseCustomerEditAccount;
      validateObject.accountId = customerAccountInfo.accountId;
      validateObject.name = customerAccountInfo.name;
      validateObject.taxId = customerAccountInfo.taxId;
      validateObject.legalAccountId = customerAccountInfo.legalAccountId;
      validateObject.affilation = customerAccountInfo.affilation;
      validateObject.authorizedBuyerFirstName =
        customerAccountInfo.authorizedBuyerFirstName;
      validateObject.authorizedBuyerLastName =
        customerAccountInfo.authorizedBuyerLastName;
      validateObject.authorizedBuyerTitle =
        customerAccountInfo.authorizedBuyerTitle;
      validateObject.authorizedBuyerPhone =
        customerAccountInfo.authorizedBuyerPhone;
      validateObject.authorizedEmailId = customerAccountInfo.authorizedEmailId;
      validateObject.paymentTerms = customerAccountInfo.paymentTerms;
      customer.name = customerAccountInfo.name;
      validateObject.country = customerAccountInfo.registerAddress.country;
      validateObject.customerRegion = customerRegion || "";
      validateObject.addresses =
        customerAccountInfo.billingAddress.country.toLocaleUpperCase() ===
        "CHINA"
          ? [
              customerAccountInfo.registerAddress,
              customerAccountInfo.billingAddress,
              customerAccountInfo.shippingAddress,
              customerAccountInfo.fapiaoAddress,
            ]
          : [
              customerAccountInfo.registerAddress,
              customerAccountInfo.billingAddress,
              customerAccountInfo.shippingAddress,
            ];
      validateObject.discount = {
        afilliationSelected: customerAccountInfo.affilation || "",
        contract: [],
        taxExempt: {
          isTaxExemptChecked: false,
          expirationDate: "",
          taxExemptReason: "",
        },
        customerGroup: {
          governmentDiscountSelected: false,
          employeePricingSelected: false,
          couponCode: couponCode,
        },
        restrictedSkus: "",
      };
      setCustomerSuccessMessage({
        message: ``,
        showMessage: false,
      });
      setCustomerFailureMessage({
        message: ``,
        showMessage: false,
      });
      
      // Get timing information from navigation state if available
      const formStartTime = location?.formStartTime;
      const activityName = location?.activityName;
      
      if (formStartTime && activityName) {
        console.log('🎯 Using form timing from button click:', {
          activityName,
          formStartTime,
          timeSpentSoFar: new Date().getTime() - new Date(formStartTime).getTime() + 'ms'
        });
      }
      
      await CustomerService.addCustomerAccount(validateObject)
        .then((res) => {
          if (res !== undefined) {
            if (res?.data?.code == 200) {
              const response = res?.data?.data?.data;
              setCustomerSuccessMessage({
                message: `New Customer Added succesfully`,
                showMessage: true,
              });
              setTimeout(() => {
                navigate("/CustomerDiscountSetup", {
                  state: {
                    editCustomer: response as ResponseCustomerEditAccount,
                    isEditFlow: false,
                  },
                });
                setLoader({
                  isLoading: false,
                  message: "",
                });
              }, 1000);
            } else if (res?.data?.code == 400) {
              const dataMessage = res?.data?.message;
              setCustomerFailureMessage({
                message: dataMessage?.split("\n").join(", "),
                showMessage: true,
              });
              if (dataMessage?.includes("Tax Id")) {
                setTaxIdError("Tax ID already exist");
                setTaxIdExist(true);
              }
              setIsSaveButtonDisabled(false);
              setLoader({
                isLoading: false,
                message: "",
              });
            }
          }
        })
        .catch((error) => {
          setLoader({
            isLoading: false,
            message: "",
          });
          appInsights.trackException({
            error: new Error(error as string),
            properties: {
              name: "Error in Add Customer account API in CustomerNewAccount.tsx",
            },
          });
        });
    } else {
      setCustomerAccountError({
        ...customerAccountErrors,
      });
      setCustomerFailureMessage({
        message: `Please enter correct value in all required fields`,
        showMessage: true,
      });
      setLoader({
        isLoading: false,
        message: "",
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  const toggleBillingNameValue = () => {
    if (!isBillingChecked) {
      setBillingDetailsHeight("460px");
      setCustomerAccountError({
        ...customerAccountError,
        billingAddress: {
          ...customerAccountError.billingAddress,
          name:
            customerAccountInfo.name.length > 0 ? "" : CUSTOMER_NAME_REQUIRED,
          street:
            customerAccountInfo.registerAddress.street.length > 0
              ? ""
              : STREET_REQUIRED,
          postalCode:
            customerAccountInfo.registerAddress.postalCode.length > 0
              ? ""
              : POSTALCODE_REQUIRED,
          city:
            customerAccountInfo.registerAddress.city.length > 0
              ? ""
              : CITY_REQUIRED,
          state:
            customerAccountInfo.registerAddress.state.length > 0
              ? ""
              : PROVINCE_REQUIRED,
          country:
            customerAccountInfo.registerAddress.country.length > 0
              ? ""
              : COUNTRY_REQUIRED,
        },
      });
      setIsBillingChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        billingAddress: {
          ...customerAccountInfo.billingAddress,
          name: customerAccountInfo.name || "",
          street: customerAccountInfo.registerAddress.street || "",
          postalCode: customerAccountInfo.registerAddress.postalCode || "",
          city: customerAccountInfo.registerAddress.city || "",
          state: customerAccountInfo.registerAddress.state || "",
          country: customerAccountInfo.registerAddress.country || "",
          purchasingCompanyTaxId: customerAccountInfo.taxId || "",
        },
      });
    } else {
      setBillingDetailsHeight("660px");
      setBillingAddressStateOptions([{ key: "", text: "", country: "" }]);
      setIsBillingChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        billingAddress: {
          ...customerAccountInfo.billingAddress,
          name: "",
          street: "",
          postalCode: "",
          city: "",
          state: "",
          country: "",
          purchasingCompanyTaxId: "",
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        billingAddress: {
          ...customerAccountError.billingAddress,
          name: CUSTOMER_NAME_REQUIRED,
          street: STREET_REQUIRED,
          postalCode: POSTALCODE_REQUIRED,
          city: CITY_REQUIRED,
          state: PROVINCE_REQUIRED,
          country: COUNTRY_REQUIRED,
        },
      });
    }
  };
  const toggleBillingContactsNameValue = () => {
    if (!isBillingContactChecked) {
      if (isBillingChecked) {
        setBillingDetailsHeight("460px");
      }
      setCustomerAccountError({
        ...customerAccountError,
        billingAddress: {
          ...customerAccountError.billingAddress,
          contacts: {
            ...customerAccountError.billingAddress.contacts,
            contactFirstName:
              customerAccountInfo.authorizedBuyerFirstName.length > 0
                ? ""
                : AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName:
              customerAccountInfo.authorizedBuyerLastName.length > 0
                ? ""
                : AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactEmail:
              customerAccountInfo.authorizedEmailId.length > 0
                ? ""
                : AUTHORIZED_BUYER_EMAIL_REQUIRED,
            contactPhone:
              customerAccountInfo.authorizedBuyerPhone.length > 0
                ? ""
                : AUTHORIZED_BUYER_PHONE_REQUIRED,
          },
        },
      });
      setIsBillingContactChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        billingAddress: {
          ...customerAccountInfo.billingAddress,
          contacts: {
            ...customerAccountInfo.billingAddress.contacts,
            contactFirstName:
              customerAccountInfo.authorizedBuyerFirstName || "",
            contactLastName: customerAccountInfo.authorizedBuyerLastName || "",
            contactEmail: customerAccountInfo.authorizedEmailId || "",
            contactPhone: customerAccountInfo.authorizedBuyerPhone || "",
          },
        },
      });
    } else {
      if (!isBillingChecked) {
        setBillingDetailsHeight("660px");
      } else {
        setBillingDetailsHeight("460px");
      }
      setIsBillingContactChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        billingAddress: {
          ...customerAccountInfo.billingAddress,
          contacts: {
            ...customerAccountInfo.billingAddress.contacts,
            contactFirstName: "",
            contactLastName: "",
            contactEmail: "",
            contactPhone: "",
          },
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        billingAddress: {
          ...customerAccountError.billingAddress,
          contacts: {
            ...customerAccountError.billingAddress.contacts,
            contactFirstName: AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName: AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
            contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
          },
        },
      });
    }
  };
  const toggleShippingNameValueByBusinessAddress = () => {
    if (!isShippingByBusinessAddressChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          name:
            customerAccountInfo.name.length > 0 ? "" : CUSTOMER_NAME_REQUIRED,
          street:
            customerAccountInfo.registerAddress.street.length > 0
              ? ""
              : STREET_REQUIRED,
          postalCode:
            customerAccountInfo.registerAddress.postalCode.length > 0
              ? ""
              : POSTALCODE_REQUIRED,
          city:
            customerAccountInfo.registerAddress.city.length > 0
              ? ""
              : CITY_REQUIRED,
          state:
            customerAccountInfo.registerAddress.state.length > 0
              ? ""
              : PROVINCE_REQUIRED,
          country:
            customerAccountInfo.registerAddress.country.length > 0
              ? ""
              : COUNTRY_REQUIRED,
        },
      });
      setIsShippingByBusinessAddressChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          name: customerAccountInfo.name || "",
          street: customerAccountInfo.registerAddress.street || "",
          postalCode: customerAccountInfo.registerAddress.postalCode || "",
          city: customerAccountInfo.registerAddress.city || "",
          state: customerAccountInfo.registerAddress.state || "",
          country: customerAccountInfo.registerAddress.country || "",
          shipmentCompanyTaxId:
            customerAccountInfo.registerAddress.registeredtaxId || "",
        },
      });
    } else {
      setShippingAddressStateOptions([{ key: "", text: "", country: "" }]);
      setIsShippingByBusinessAddressChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          name: "",
          street: "",
          postalCode: "",
          city: "",
          state: "",
          country: "",
          shipmentCompanyTaxId: "",
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          name: CUSTOMER_NAME_REQUIRED,
          street: STREET_REQUIRED,
          postalCode: POSTALCODE_REQUIRED,
          city: CITY_REQUIRED,
          state: PROVINCE_REQUIRED,
          country: COUNTRY_REQUIRED,
        },
      });
    }
  };
  const toggleShippingContactsNameValueByBusinessContact = () => {
    if (!isShippingByBusinessContactChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          contacts: {
            ...customerAccountError.shippingAddress.contacts,
            contactFirstName:
              customerAccountInfo.authorizedBuyerFirstName.length > 0
                ? ""
                : AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName:
              customerAccountInfo.authorizedBuyerLastName.length > 0
                ? ""
                : AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactEmail:
              customerAccountInfo.authorizedEmailId.length > 0
                ? ""
                : AUTHORIZED_BUYER_EMAIL_REQUIRED,
            contactPhone:
              customerAccountInfo.authorizedBuyerPhone.length > 0
                ? ""
                : AUTHORIZED_BUYER_PHONE_REQUIRED,
          },
        },
      });
      setIsShippingByBusinessContactChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          contacts: {
            ...customerAccountInfo.shippingAddress.contacts,
            contactFirstName:
              customerAccountInfo.authorizedBuyerFirstName || "",
            contactLastName: customerAccountInfo.authorizedBuyerLastName || "",
            contactEmail: customerAccountInfo.authorizedEmailId || "",
            contactPhone: customerAccountInfo.authorizedBuyerPhone || "",
          },
        },
      });
    } else {
      setIsShippingByBusinessContactChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          contacts: {
            ...customerAccountInfo.shippingAddress.contacts,
            contactFirstName: "",
            contactLastName: "",
            contactEmail: "",
            contactPhone: "",
          },
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          contacts: {
            ...customerAccountError.shippingAddress.contacts,
            contactFirstName: AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName: AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
            contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
          },
        },
      });
    }
  };
  const toggleShippingNameValue = () => {
    if (!isShippingChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          name:
            customerAccountInfo.billingAddress.name.length > 0
              ? ""
              : CUSTOMER_NAME_REQUIRED,
          street:
            customerAccountInfo.billingAddress.street.length > 0
              ? ""
              : STREET_REQUIRED,
          postalCode:
            customerAccountInfo.billingAddress.postalCode.length > 0
              ? ""
              : POSTALCODE_REQUIRED,
          city:
            customerAccountInfo.billingAddress.city.length > 0
              ? ""
              : CITY_REQUIRED,
          state:
            customerAccountInfo.billingAddress.state.length > 0
              ? ""
              : PROVINCE_REQUIRED,
          country:
            customerAccountInfo.billingAddress.country.length > 0
              ? ""
              : COUNTRY_REQUIRED,
        },
      });
      setIsShippingChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          name: customerAccountInfo.billingAddress.name || "",
          street: customerAccountInfo.billingAddress.street || "",
          postalCode: customerAccountInfo.billingAddress.postalCode || "",
          city: customerAccountInfo.billingAddress.city || "",
          state: customerAccountInfo.billingAddress.state || "",
          country: customerAccountInfo.billingAddress.country || "",
          shipmentCompanyTaxId:
            customerAccountInfo.billingAddress.purchasingCompanyTaxId || "",
        },
      });
    } else {
      setShippingAddressStateOptions([{ key: "", text: "", country: "" }]);
      setIsShippingChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          name: "",
          street: "",
          postalCode: "",
          city: "",
          state: "",
          country: "",
          shipmentCompanyTaxId: "",
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          name: CUSTOMER_NAME_REQUIRED,
          street: STREET_REQUIRED,
          postalCode: POSTALCODE_REQUIRED,
          city: CITY_REQUIRED,
          state: PROVINCE_REQUIRED,
          country: COUNTRY_REQUIRED,
        },
      });
    }
  };
  const toggleShippingContactsNameValue = () => {
    if (!isShippingContactChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          contacts: {
            ...customerAccountError.shippingAddress.contacts,
            contactFirstName:
              customerAccountInfo.billingAddress.contacts.contactFirstName &&
              customerAccountInfo.billingAddress.contacts.contactFirstName
                .length > 0
                ? ""
                : AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName:
              customerAccountInfo.billingAddress.contacts.contactLastName &&
              customerAccountInfo.billingAddress.contacts.contactLastName
                .length > 0
                ? ""
                : AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactEmail:
              customerAccountInfo.billingAddress.contacts.contactEmail &&
              customerAccountInfo.billingAddress.contacts.contactEmail.length >
                0
                ? ""
                : AUTHORIZED_BUYER_EMAIL_REQUIRED,
            contactPhone:
              customerAccountInfo.billingAddress.contacts.contactPhone &&
              customerAccountInfo.billingAddress.contacts.contactPhone.length >
                0
                ? ""
                : AUTHORIZED_BUYER_PHONE_REQUIRED,
          },
        },
      });
      setIsShippingContactChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          contacts: {
            ...customerAccountInfo.shippingAddress.contacts,
            contactFirstName:
              customerAccountInfo.billingAddress.contacts.contactFirstName ||
              "",
            contactLastName:
              customerAccountInfo.billingAddress.contacts.contactLastName || "",
            contactEmail:
              customerAccountInfo.billingAddress.contacts.contactEmail || "",
            contactPhone:
              customerAccountInfo.billingAddress.contacts.contactPhone || "",
          },
        },
      });
    } else {
      setIsShippingContactChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        shippingAddress: {
          ...customerAccountInfo.shippingAddress,
          contacts: {
            ...customerAccountInfo.shippingAddress.contacts,
            contactFirstName: "",
            contactLastName: "",
            contactEmail: "",
            contactPhone: "",
          },
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        shippingAddress: {
          ...customerAccountError.shippingAddress,
          contacts: {
            ...customerAccountError.shippingAddress.contacts,
            contactFirstName: AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
            contactLastName: AUTHORIZED_BUYER_LASTNAME_REQUIRED,
            contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
            contactEmail: AUTHORIZED_BUYER_EMAIL_REQUIRED,
          },
        },
      });
    }
  };
  const toggleFapiaoNameValue = () => {
    if (!isFapiaoChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        fapiaoAddress: {
          ...customerAccountError.fapiaoAddress,
          name:
            customerAccountInfo.billingAddress.name.length > 0
              ? ""
              : CUSTOMER_NAME_REQUIRED,
          street:
            customerAccountInfo.billingAddress.street.length > 0
              ? ""
              : STREET_REQUIRED,
          postalCode:
            customerAccountInfo.billingAddress.postalCode.length > 0
              ? ""
              : POSTALCODE_REQUIRED,
          city:
            customerAccountInfo.billingAddress.city.length > 0
              ? ""
              : CITY_REQUIRED,
          state:
            customerAccountInfo.billingAddress.state.length > 0
              ? ""
              : PROVINCE_REQUIRED,
          country:
            customerAccountInfo.billingAddress.country.length > 0
              ? ""
              : COUNTRY_REQUIRED,
        },
      });
      setIsFapiaoChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        fapiaoAddress: {
          ...customerAccountInfo.fapiaoAddress,
          name: customerAccountInfo.billingAddress.name || "",
          street: customerAccountInfo.billingAddress.street || "",
          postalCode: customerAccountInfo.billingAddress.postalCode || "",
          city: customerAccountInfo.billingAddress.city || "",
          state: customerAccountInfo.billingAddress.state || "",
          country: customerAccountInfo.billingAddress.country || "",
        },
      });
    } else {
      setIsFapiaoChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        fapiaoAddress: {
          ...customerAccountInfo.fapiaoAddress,
          name: "",
          street: "",
          postalCode: "",
          city: "",
          state: "",
          country: "",
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        fapiaoAddress: {
          ...customerAccountError.fapiaoAddress,
          name: CUSTOMER_NAME_REQUIRED,
          street: STREET_REQUIRED,
          postalCode: POSTALCODE_REQUIRED,
          city: CITY_REQUIRED,
          state: PROVINCE_REQUIRED,
          country: COUNTRY_REQUIRED,
        },
      });
    }
  };
  const toggleFapiaoContactsNameValue = () => {
    if (!isfapiaoContactChecked) {
      setCustomerAccountError({
        ...customerAccountError,
        fapiaoAddress: {
          ...customerAccountError.fapiaoAddress,
          contacts: {
            ...customerAccountError.fapiaoAddress.contacts,
            contactPhone:
              customerAccountInfo.billingAddress.contacts.contactPhone &&
              customerAccountInfo.billingAddress.contacts.contactPhone.length >
                0
                ? ""
                : AUTHORIZED_BUYER_PHONE_REQUIRED,
          },
        },
      });
      setIsFapiaoContactChecked(true);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        fapiaoAddress: {
          ...customerAccountInfo.fapiaoAddress,
          contacts: {
            ...customerAccountInfo.fapiaoAddress.contacts,
            contactPhone:
              customerAccountInfo.billingAddress.contacts.contactPhone || "",
          },
        },
      });
    } else {
      setIsFapiaoContactChecked(false);
      setCustomerAccountInfo({
        ...customerAccountInfo,
        fapiaoAddress: {
          ...customerAccountInfo.fapiaoAddress,
          contacts: {
            ...customerAccountInfo.fapiaoAddress.contacts,
            contactPhone: "",
          },
        },
      });
      setCustomerAccountError({
        ...customerAccountError,
        fapiaoAddress: {
          ...customerAccountError.fapiaoAddress,
          contacts: {
            ...customerAccountError.fapiaoAddress.contacts,
            contactPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
          },
        },
      });
    }
  };
  const regionWiseCountry =
    countryOptions &&
    countryOptions
      ?.filter((country) => userRegions.includes(country.region))
      .sort((a, b) => a.text.localeCompare(b.text));
  const [selectedBusinessSoldToCountry, setSelectedBusinessSoldToCountry] =
    useState(countryIntialValue);
  useEffect(() => {
    const filteredCountries =
      countryOptions &&
      countryOptions?.filter(
        (country) => country.key === customerAccountInfo.registerAddress.country
      );
    setSelectedBusinessSoldToCountry(filteredCountries);
  }, [customerAccountInfo.registerAddress.country]);
  return customerAccountInfo.accountId ? (
    <Stack
      verticalFill
      verticalAlign="start"
      tokens={stackTokensWithGap10}
      style={{ backgroundColor: "#FAF9F8" }}
    >
      {customerSuccessMessage.showMessage && (
        <MessageBar
          messageBarType={MessageBarType.success}
          onDismiss={() =>
            setCustomerSuccessMessage(InitialStateOfResponseMessage)
          }
        >
          {customerSuccessMessage.message}
        </MessageBar>
      )}
      {customerFailureMessage.showMessage && (
        <MessageBar
          messageBarType={MessageBarType.error}
          onDismiss={() =>
            setCustomerFailureMessage(InitialStateOfResponseMessage)
          }
        >
          {customerFailureMessage.message}
        </MessageBar>
      )}
      <Breadcrumb
        items={getBreadcrumbItems()}
        style={{ marginLeft: "0", marginBottom: "-5px" }}
        styles={BreadcrumbStyle}
      />
      <Stack horizontal tokens={{ childrenGap: 50 }}>
        <Card>
          <h1
            style={{
              fontSize: FontSizes.size18,
              display: "inline",
              fontWeight: FontWeights.bold,
            }}
            role="heading"
            title="New Customer Details"
            aria-label="New Customer Details"
            aria-labelledby="New Customer Details"
          >
            {`New Customer Details`}
          </h1>
        </Card>
      </Stack>
      {loader?.isLoading ? (
        <div style={LoadingContainerStyle}>
          <LoadingState primaryText={loader.message} styles={{}} />
        </div>
      ) : (
        <Stack style={{ overflowY: "auto" }}>
          <Stack horizontal style={cardSize}>
            <Card
              styles={{
                layout: { width: "700px" },
                footer: { padding: "0" },
                root: { paddingBottom: "20px" },
              }}
              header={<CardStandardHeader cardTitle="Business Information" />}
            >
              <Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    tabIndex={-1}
                    autoFocus={false}
                    styles={TextGrayFieldStyles}
                    label="Customer Account ID"
                    name="customerAccountId"
                    ariaLabel="Customer Account ID"
                    value={customerAccountInfo.accountId}
                    errorMessage={customerAccountError?.accountId}
                    readOnly
                    autoComplete="off"
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Customer Name (Legal Entity)"
                    name="customerName"
                    required
                    autoComplete="off"
                    ariaLabel="Customer Name (Legal Entity)"
                    value={customerAccountInfo.name}
                    onChange={(e, customerNameValue) => {
                      // Validation logic
                      if (customerNameValue && customerNameValue?.length > 0) {
                        var specialCharacterCustomerName =
                          allowSpecialCharacterExcludingSome.test(
                            customerNameValue
                          );
                        if (specialCharacterCustomerName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            name: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          name: CUSTOMER_NAME_REQUIRED,
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        name: customerNameValue || "",
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          name: customerNameValue || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          name: customerNameValue || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo.name &&
                        customerAccountInfo?.name?.length > 0
                      ) {
                        var specialCharacterCustomerName =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo.name
                          );
                        if (
                          customerAccountInfo.name.length >
                          companyNameCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            name: CUSTOMER_NAME_CHARACTER_LIMIT,
                          });
                        } else if (specialCharacterCustomerName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            name: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          name: CUSTOMER_NAME_REQUIRED,
                        });
                      }
                    }}
                    errorMessage={customerAccountError.name}
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label="Sold To SAP Account ID"
                    name="sapAccountId"
                    ariaLabel="Sold To SAP Account ID"
                    value={customerAccountInfo.sapAccountId}
                    autoComplete="off"
                    onChange={(e, sapAccountIdValue) => {
                      if (sapAccountIdValue && sapAccountIdValue?.length > 0) {
                        var sapAccountNumberOnly =
                          numbersOnly.test(sapAccountIdValue);
                        if (sapAccountNumberOnly) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            sapAccountId: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            sapAccountId: NUMBERS_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          sapAccountId: "",
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        sapAccountId: sapAccountIdValue || "",
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          sapAccountId: sapAccountIdValue || "",
                        },
                      });
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.sapAccountId &&
                        customerAccountInfo?.sapAccountId?.length > 0
                      ) {
                        var sapAccountNumberOnly = numbersOnly.test(
                          customerAccountInfo?.sapAccountId
                        );
                        if (sapAccountNumberOnly) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            sapAccountId: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            sapAccountId: NUMBERS_ALLOWED,
                          });
                        }
                      }
                    }}
                    errorMessage={customerAccountError.sapAccountId}
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Lead Account ID (MSX)"
                    name="leadAccountId"
                    required
                    ariaLabel="Lead Account ID (MSX)"
                    autoComplete="off"
                    value={customerAccountInfo.legalAccountId}
                    onChange={(e, legalAccountIdValue) => {
                      if (
                        legalAccountIdValue &&
                        legalAccountIdValue?.length > 0
                      ) {
                        setCustomerAccountError({
                          ...customerAccountError,
                          legalAccountId: "",
                        });
                        validateMsxOppertunityIdCheck(
                          legalAccountIdValue,
                          setMsxIdError,
                          setMsxIdExist
                        );
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          legalAccountId: LEADACCOUNT_ID_REQUIRED,
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        legalAccountId: legalAccountIdValue || "",
                      });
                    }}
                    errorMessage={
                      msxIdError === ""
                        ? customerAccountError.legalAccountId
                        : msxIdError
                    }
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <ComboBox
                    data-testid="customer-account-select"
                    styles={customerNewAccountComboBoxStyle}
                    label="Type/Affiliation"
                    ariaLabel="Type/Affiliation"
                    autoComplete="off"
                    required
                    options={typeAffilationOptions}
                    selectedKey={customerAccountInfo.affilation}
                    onChange={(e, affilationValue) => {
                      if (affilationValue && affilationValue?.text.length > 0) {
                        setCustomerAccountError({
                          ...customerAccountError,
                          affilation: "",
                        });
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          affilation: "Affilation is Required",
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        affilation: affilationValue?.text.toString() ?? "",
                      });
                    }}
                    errorMessage={customerAccountError.affilation}
                  />
                  <ComboBox
                    data-testid="customer-payment-select"
                    styles={customerNewAccountComboBoxStyle}
                    label="Payment Terms"
                    ariaLabel="Payment Terms"
                    autoComplete="off"
                    required
                    options={paymentTermsOptions}
                    selectedKey={customerAccountInfo.paymentTerms}
                    onChange={(e, paymentTermsValue) => {
                      if (
                        paymentTermsValue &&
                        paymentTermsValue?.text.length > 0
                      ) {
                        setCustomerAccountError({
                          ...customerAccountError,
                          paymentTerms: "",
                        });
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          paymentTerms: "Payment Terms is Required",
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        paymentTerms: paymentTermsValue?.key.toString() || "",
                      });
                    }}
                    errorMessage={customerAccountError.paymentTerms}
                  />
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack horizontal style={cardSize}>
            <Card
              styles={{
                layout: { width: "700px" },
                footer: { padding: "0" },
                root: { paddingBottom: "20px" },
              }}
              header={
                <CardStandardHeader cardTitle="Contact/Authorized Buyer" />
              }
            >
              <Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label="First Name"
                    name="contactFirstName"
                    ariaLabel="First Name"
                    required
                    value={customerAccountInfo.authorizedBuyerFirstName}
                    onChange={(e, contactFirstNameValue) => {
                      // Validation logic
                      if (
                        contactFirstNameValue &&
                        contactFirstNameValue?.length > 0
                      ) {
                        var characterCustomerAuthorizedBuyerFirstName =
                          allowSpecialCharacterExcludingSome.test(
                            contactFirstNameValue
                          );
                        if (characterCustomerAuthorizedBuyerFirstName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerFirstName: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerFirstName:
                              CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerFirstName:
                            AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        authorizedBuyerFirstName: contactFirstNameValue || "",
                      };

                      // Update billing contact if the checkbox is checked
                      if (isBillingContactChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          contacts: {
                            ...updatedAccountInfo.billingAddress.contacts,
                            contactFirstName: contactFirstNameValue || "",
                          },
                        };
                      }

                      // Update shipping contact if the checkbox is checked
                      if (isShippingByBusinessContactChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          contacts: {
                            ...updatedAccountInfo.shippingAddress.contacts,
                            contactFirstName: contactFirstNameValue || "",
                          },
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.authorizedBuyerFirstName &&
                        customerAccountInfo?.authorizedBuyerFirstName?.length >
                          0
                      ) {
                        var characterCustomerAuthorizedBuyerFirstName =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.authorizedBuyerFirstName
                          );
                        if (
                          customerAccountInfo?.authorizedBuyerFirstName.length >
                          contactNameCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerFirstName:
                              CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                          });
                        } else if (characterCustomerAuthorizedBuyerFirstName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerFirstName: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerFirstName:
                              CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerFirstName:
                            AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                        });
                      }
                    }}
                    errorMessage={customerAccountError.authorizedBuyerFirstName}
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Last Name"
                    name="contactLastName"
                    ariaLabel="Last Name"
                    required
                    value={customerAccountInfo.authorizedBuyerLastName}
                    onChange={(e, contactLastNameValue) => {
                      // Validation logic
                      if (
                        contactLastNameValue &&
                        contactLastNameValue?.length > 0
                      ) {
                        var characterCustomerAuthorizedBuyerLastName =
                          allowSpecialCharacterExcludingSome.test(
                            contactLastNameValue
                          );
                        if (characterCustomerAuthorizedBuyerLastName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerLastName: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerLastName:
                              CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerLastName:
                            AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        authorizedBuyerLastName: contactLastNameValue || "",
                      };

                      // Update billing contact if the checkbox is checked
                      if (isBillingContactChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          contacts: {
                            ...updatedAccountInfo.billingAddress.contacts,
                            contactLastName: contactLastNameValue || "",
                          },
                        };
                      }

                      // Update shipping contact if the checkbox is checked
                      if (isShippingByBusinessContactChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          contacts: {
                            ...updatedAccountInfo.shippingAddress.contacts,
                            contactLastName: contactLastNameValue || "",
                          },
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.authorizedBuyerLastName &&
                        customerAccountInfo?.authorizedBuyerLastName?.length > 0
                      ) {
                        var characterCustomerAuthorizedBuyerLastName =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.authorizedBuyerLastName
                          );
                        if (
                          customerAccountInfo?.authorizedBuyerLastName.length >
                          contactNameCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerLastName:
                              CONTACT_LASTNAME_CHARACTER_LIMIT,
                          });
                        } else if (characterCustomerAuthorizedBuyerLastName) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerLastName: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerLastName:
                              CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerLastName:
                            AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                        });
                      }
                    }}
                    errorMessage={customerAccountError.authorizedBuyerLastName}
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={EditComboBoxStyles}
                    label="Job Title"
                    name="Job Title"
                    ariaLabel="Job Title"
                    required
                    value={customerAccountInfo.authorizedBuyerTitle}
                    onChange={(e, authorizedBuyerTitleValue) => {
                      if (
                        authorizedBuyerTitleValue &&
                        authorizedBuyerTitleValue?.length > 0
                      ) {
                        var specialCharacterCustomerTitleCode =
                          allowSpecialCharacterExcludingSome.test(
                            authorizedBuyerTitleValue
                          );
                        if (specialCharacterCustomerTitleCode) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerTitle: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerTitle:
                              SPECIAL_CHARACTERS_NOT_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerTitle: "Title is Required",
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        authorizedBuyerTitle:
                          authorizedBuyerTitleValue?.toString() ?? "",
                      });
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.authorizedBuyerTitle &&
                        customerAccountInfo?.authorizedBuyerTitle?.length > 0
                      ) {
                        var specialCharacterCustomerTitleCode =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.authorizedBuyerTitle
                          );
                        if (specialCharacterCustomerTitleCode) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerTitle: "",
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerTitle:
                              SPECIAL_CHARACTERS_NOT_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerTitle: "Title is Required",
                        });
                      }
                    }}
                    errorMessage={customerAccountError.authorizedBuyerTitle}
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Phone"
                    name="contactPhone"
                    ariaLabel="Phone"
                    required
                    value={customerAccountInfo.authorizedBuyerPhone}
                    onChange={(e, contactPhoneValue) => {
                      // Validation logic
                      let phoneError = "";
                      if (contactPhoneValue && contactPhoneValue?.length > 0) {
                        var characterCustomerContactPhone =
                          contactNumberRegex.test(contactPhoneValue);
                        if (!characterCustomerContactPhone) {
                          phoneError = SPECIL_CHARACTER_INVALID_PHONENUMBER;
                        }
                      } else {
                        phoneError = AUTHORIZED_BUYER_PHONE_REQUIRED;
                      }

                      // Set error state
                      setCustomerAccountError({
                        ...customerAccountError,
                        authorizedBuyerPhone: phoneError,
                      });

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        authorizedBuyerPhone: contactPhoneValue || "",
                      };

                      // Update billing contact if the checkbox is checked
                      if (isBillingContactChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          contacts: {
                            ...updatedAccountInfo.billingAddress.contacts,
                            contactPhone: contactPhoneValue || "",
                          },
                        };
                      }

                      // Update shipping contact if the checkbox is checked
                      if (isShippingByBusinessContactChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          contacts: {
                            ...updatedAccountInfo.shippingAddress.contacts,
                            contactPhone: contactPhoneValue || "",
                          },
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.authorizedBuyerPhone &&
                        customerAccountInfo?.authorizedBuyerPhone?.length > 0
                      ) {
                        var checkLength = phoneNumberRegex.test(
                          customerAccountInfo?.authorizedBuyerPhone
                        );
                        var characterCustomerContactPhone =
                          contactNumberRegex.test(
                            customerAccountInfo.authorizedBuyerPhone
                          );
                        if (characterCustomerContactPhone) {
                          if (!checkLength) {
                            setCustomerAccountError({
                              ...customerAccountError,
                              authorizedBuyerPhone: INVALID_PHONENUMBER,
                            });
                          } else {
                            setCustomerAccountError({
                              ...customerAccountError,
                              authorizedBuyerPhone: "",
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedBuyerPhone:
                              SPECIL_CHARACTER_INVALID_PHONENUMBER,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedBuyerPhone: AUTHORIZED_BUYER_PHONE_REQUIRED,
                        });
                      }
                    }}
                    errorMessage={customerAccountError.authorizedBuyerPhone}
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label="Email"
                    name="contactEmail"
                    ariaLabel="Email"
                    required
                    value={customerAccountInfo.authorizedEmailId}
                    onChange={(e, contactEmailValue) => {
                      // Validation logic
                      let emailError = "";
                      if (contactEmailValue && contactEmailValue?.length > 0) {
                        var characterCustomerAuthorizedEmailId =
                          allowSpecialCharacterExcludingSome.test(
                            contactEmailValue
                          );
                        if (!characterCustomerAuthorizedEmailId) {
                          emailError = SOME_SPECIAL_CHARACTERS_NOT_ALLOWED;
                        }
                      } else {
                        emailError = AUTHORIZED_BUYER_EMAIL_REQUIRED;
                      }

                      // Set error state
                      setCustomerAccountError({
                        ...customerAccountError,
                        authorizedEmailId: emailError,
                      });

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        authorizedEmailId: contactEmailValue || "",
                      };

                      // Update billing contact if the checkbox is checked
                      if (isBillingContactChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          contacts: {
                            ...updatedAccountInfo.billingAddress.contacts,
                            contactEmail: contactEmailValue || "",
                          },
                        };
                      }

                      // Update shipping contact if the checkbox is checked
                      if (isShippingByBusinessContactChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          contacts: {
                            ...updatedAccountInfo.shippingAddress.contacts,
                            contactEmail: contactEmailValue || "",
                          },
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo.authorizedEmailId &&
                        customerAccountInfo.authorizedEmailId?.length > 0
                      ) {
                        var emailCustomerAuthorizedEmailId = emailRegex.test(
                          customerAccountInfo.authorizedEmailId
                        );
                        var characterCustomerAuthorizedEmailId =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo.authorizedEmailId
                          );
                        if (
                          customerAccountInfo.authorizedEmailId?.length >
                          emailCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedEmailId: EMAIL_CHARACTER_LIMIT,
                          });
                        } else if (characterCustomerAuthorizedEmailId) {
                          if (emailCustomerAuthorizedEmailId) {
                            setCustomerAccountError({
                              ...customerAccountError,
                              authorizedEmailId: "",
                            });
                          } else {
                            setCustomerAccountError({
                              ...customerAccountError,
                              authorizedEmailId: EMAIL_VALIDATION,
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            authorizedEmailId: SPECIAL_CHARACTERS_NOT_ALLOWED,
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          authorizedEmailId: AUTHORIZED_BUYER_EMAIL_REQUIRED,
                        });
                      }
                    }}
                    errorMessage={customerAccountError.authorizedEmailId}
                  />
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack horizontal style={cardSize}>
            <Card
              styles={{
                layout: { width: "700px" },
                footer: { padding: "0" },
                root: { paddingBottom: "20px" },
              }}
              header={
                <CardStandardHeader cardTitle="Business/Sold To Address (Legal Entity)" />
              }
            >
              <Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <ComboBox
                    styles={customerNewAccountComboBoxStyle}
                    label="Country"
                    ariaLabel="Country"
                    required
                    options={regionWiseCountry}
                    selectedKey={customerAccountInfo.registerAddress.country}
                    onChange={(e, countryValue) => {
                      // Validation logic
                      if (countryValue && countryValue?.text.length > 0) {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            country: "",
                          },
                        });
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            country: COUNTRY_REQUIRED,
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          country: countryValue?.text.toString() || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          country: countryValue?.text.toString() || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          country: countryValue?.text.toString() || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);

                      const registerAddressStateList = countryWiseStateList
                        .filter(
                          (x) =>
                            x.country.toLocaleLowerCase() ===
                            countryValue?.text.toLocaleLowerCase()
                        )
                        .sort((a, b) => a.text.localeCompare(b.text));
                      setRegisteredAddressStateOptions(
                        registerAddressStateList
                      );
                    }}
                    errorMessage={customerAccountError.registerAddress.country}
                  />
                  <ComboBox
                    styles={customerNewAccountComboBoxStyle}
                    label="State/Province"
                    ariaLabel="State/Province"
                    options={registeredAddressStateOptions}
                    required
                    selectedKey={customerAccountInfo.registerAddress.state}
                    onChange={(e, stateValue) => {
                      // Validation logic
                      if (stateValue && stateValue?.text.length > 0) {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            state: "",
                          },
                        });
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            state: PROVINCE_REQUIRED,
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          state: stateValue?.text.toString() || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          state: stateValue?.text.toString() || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          state: stateValue?.text.toString() || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    errorMessage={customerAccountError.registerAddress.state}
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label="Street (Must not be P.O. Box)"
                    name="street"
                    ariaLabel="Street (Must not be P.O. Box)"
                    required
                    value={customerAccountInfo.registerAddress.street}
                    onChange={(e, streetValue) => {
                      // Validation logic
                      if (streetValue && streetValue?.length > 0) {
                        var registeredAddressStreetLength = streetValue.length;
                        var poBoxRegexSpecialCharacterStreetPattern =
                          allowSpecialCharacterExcludingSome.test(streetValue);
                        if (registeredAddressStreetLength <= 60) {
                          if (!poBoxRegexSpecialCharacterStreetPattern) {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              },
                            });
                          } else {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                street: "",
                              },
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              street:
                                "Street Length should not be greater than 60 characters",
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            street: STREET_REQUIRED,
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          street: streetValue || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          street: streetValue || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          street: streetValue || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.registerAddress?.street &&
                        customerAccountInfo?.registerAddress?.street?.length > 0
                      ) {
                        var registeredAddressStreetLength =
                          customerAccountInfo?.registerAddress?.street.length;
                        var poBoxRegexStreetPattern = poBoxRegex.test(
                          customerAccountInfo?.registerAddress?.street
                        );
                        var poBoxRegexSpecialCharacterStreetPattern =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.registerAddress?.street
                          );
                        if (registeredAddressStreetLength <= 60) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              street: "",
                            },
                          });
                          if (poBoxRegexSpecialCharacterStreetPattern) {
                            if (poBoxRegexStreetPattern) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                registerAddress: {
                                  ...customerAccountError.registerAddress,
                                  street: Street_PO_BOX_VALIDATION,
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                registerAddress: {
                                  ...customerAccountError.registerAddress,
                                  street: "",
                                },
                              });
                            }
                          } else {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                street: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                              },
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              street:
                                "Street Length should not be greater than 60 characters",
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            street: STREET_REQUIRED,
                          },
                        });
                      }
                    }}
                    errorMessage={customerAccountError.registerAddress.street}
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Zip/Postal Code"
                    name="postalCode"
                    ariaLabel="Zip/Postal Code"
                    required
                    value={customerAccountInfo.registerAddress.postalCode}
                    onChange={(e, postalCodeValue) => {
                      // Validation logic
                      if (postalCodeValue && postalCodeValue?.length > 0) {
                        var specialCharacterCustomerPostalCode =
                          allowSpecialCharacterExcludingSome.test(
                            postalCodeValue
                          );
                        if (specialCharacterCustomerPostalCode) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              postalCode: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            postalCode: POSTALCODE_REQUIRED,
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          postalCode: postalCodeValue || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          postalCode: postalCodeValue || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          postalCode: postalCodeValue || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.registerAddress?.postalCode &&
                        customerAccountInfo?.registerAddress?.postalCode
                          ?.length > 0
                      ) {
                        var specialCharacterCustomerPostalCode =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.registerAddress?.postalCode
                          );
                        if (
                          customerAccountInfo.registerAddress.postalCode
                            .length > postalCodeCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              postalCode: POSTALCODE_CHARACTER_LIMIT,
                            },
                          });
                        } else if (specialCharacterCustomerPostalCode) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              postalCode: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            postalCode: POSTALCODE_REQUIRED,
                          },
                        });
                      }
                    }}
                    errorMessage={
                      customerAccountError.registerAddress.postalCode
                    }
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label="City"
                    name="city"
                    ariaLabel="City"
                    required
                    value={customerAccountInfo.registerAddress.city}
                    onChange={(e, cityValue) => {
                      // Validation logic
                      if (cityValue && cityValue?.length > 0) {
                        var characterCustomerCity =
                          allowSpecialCharacterExcludingSome.test(cityValue);
                        if (characterCustomerCity) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              city: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            city: CITY_REQUIRED,
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          city: cityValue || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          city: cityValue || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          city: cityValue || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.registerAddress?.city &&
                        customerAccountInfo?.registerAddress?.city?.length > 0
                      ) {
                        var characterCustomerCity =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.registerAddress?.city
                          );
                        if (
                          customerAccountInfo?.registerAddress?.city.length >
                          cityCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              city: CITY_CHARACTER_LIMIT,
                            },
                          });
                        } else if (characterCustomerCity) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              city: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            city: CITY_REQUIRED,
                          },
                        });
                      }
                    }}
                    errorMessage={customerAccountError.registerAddress.city}
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label="Tax ID (Legal Entity)"
                    name="CompanyTaxId"
                    ariaLabel="Tax ID (Legal Entity)"
                    value={customerAccountInfo.registerAddress.registeredtaxId}
                    onChange={(e, registeredtaxIdValue) => {
                      if (registeredtaxIdValue?.toLocaleLowerCase() === "n/a") {
                        registeredtaxIdValue = "";
                        setTaxIdError("");
                        setTaxIdExist(false);
                      }

                      // Validation logic
                      if (
                        registeredtaxIdValue !== undefined &&
                        registeredtaxIdValue !== null &&
                        registeredtaxIdValue !== ""
                      ) {
                        var specialCharacterCompanyTaxId =
                          allowSpecialCharacterExcludingSome.test(
                            registeredtaxIdValue
                          );
                        if (specialCharacterCompanyTaxId) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              registeredtaxId: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              registeredtaxId:
                                CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setTaxIdError("");
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            registeredtaxId: "",
                          },
                        });
                      }

                      // Single state update with all changes
                      const updatedAccountInfo = {
                        ...customerAccountInfo,
                        taxId: registeredtaxIdValue || "",
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          registeredtaxId: registeredtaxIdValue || "",
                        },
                      };

                      // Update billing address if the checkbox is checked
                      if (isBillingChecked) {
                        updatedAccountInfo.billingAddress = {
                          ...updatedAccountInfo.billingAddress,
                          purchasingCompanyTaxId: registeredtaxIdValue || "",
                        };
                      }

                      // Update shipping address if the checkbox is checked
                      if (isShippingByBusinessAddressChecked) {
                        updatedAccountInfo.shippingAddress = {
                          ...updatedAccountInfo.shippingAddress,
                          shipmentCompanyTaxId: registeredtaxIdValue || "",
                        };
                      }

                      setCustomerAccountInfo(updatedAccountInfo);
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.registerAddress
                          ?.registeredtaxId !== undefined &&
                        customerAccountInfo?.registerAddress
                          ?.registeredtaxId !== null &&
                        customerAccountInfo?.registerAddress
                          ?.registeredtaxId !== ""
                      ) {
                        var specialCharacterCompanyTaxId =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo?.registerAddress
                              ?.registeredtaxId
                          );
                        var specialCharacterCompanyTaxIdNAALlowed =
                          uiNAPattern.test(
                            customerAccountInfo?.registerAddress
                              ?.registeredtaxId
                          );
                        if (
                          customerAccountInfo?.registerAddress?.registeredtaxId
                            .length > companyTaxIdCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              registeredtaxId: COMPANY_TAXID_CHARACTER_LIMIT,
                            },
                          });
                        } else if (specialCharacterCompanyTaxId) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              registeredtaxId: "",
                            },
                          });
                          if (!specialCharacterCompanyTaxIdNAALlowed) {
                            validateCustomerTaxIdCheck(
                              customerAccountInfo?.registerAddress
                                ?.registeredtaxId,
                              setTaxIdError,
                              setTaxIdExist
                            );
                          } else if (specialCharacterCompanyTaxIdNAALlowed) {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                registeredtaxId: "",
                              },
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              registeredtaxId:
                                CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setTaxIdError("");
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            registeredtaxId: "", // Changed from TAX_ID_REQUIRED to empty string
                          },
                        });
                      }
                    }}
                    errorMessage={
                      taxIdError === ""
                        ? customerAccountError.registerAddress.registeredtaxId
                        : taxIdError
                    }
                  />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <TextField
                    styles={TextFieldStyles}
                    label={customerAccountInfo.registerAddress.country?.toLowerCase() === "italy" 
                      ? "Customer Certified Email*" 
                      : "Customer Certified Email"}
                    name="Customer certified email"
                    ariaLabel="CustomerCertifiedEmail"
                    required={customerAccountInfo.registerAddress.country?.toLowerCase() === "italy"}
                    value={
                      customerAccountInfo.registerAddress.customerCertifiedEmail
                    }
                    onChange={(e, customerCertifiedEmail) => {
                      if (
                        isBillingChecked ||
                        isShippingByBusinessAddressChecked
                      ) {
                        // Update billing address if the checkbox is checked
                        if (isBillingChecked) {
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            billingAddress: {
                              ...customerAccountInfo.billingAddress,
                              customerCertifiedEmail:
                                customerCertifiedEmail || "",
                            },
                          });
                        }

                        // Update shipping address if the checkbox is checked
                        if (isShippingByBusinessAddressChecked) {
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            shippingAddress: {
                              ...customerAccountInfo.shippingAddress,
                              customerCertifiedEmail:
                                customerCertifiedEmail || "",
                            },
                          });
                        }
                      }
                      if (
                        customerCertifiedEmail &&
                        customerCertifiedEmail?.length > 0
                      ) {
                        var characterCustomerAuthorizedEmailId =
                          allowSpecialCharacterExcludingSome.test(
                            customerCertifiedEmail
                          );
                        if (characterCustomerAuthorizedEmailId) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerCertifiedEmail: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerCertifiedEmail:
                                SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            customerCertifiedEmail: "",
                          },
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          customerCertifiedEmail: customerCertifiedEmail || "",
                        },
                      });
                    }}
                    onBlur={() => {
                      if (
                        customerAccountInfo?.registerAddress
                          ?.customerCertifiedEmail &&
                        customerAccountInfo.registerAddress
                          .customerCertifiedEmail?.length > 0
                      ) {
                        var emailCustomerCertifiedEmailId = emailRegex.test(
                          customerAccountInfo.registerAddress
                            .customerCertifiedEmail
                        );
                        var characterCustomerAuthorizedEmailId =
                          allowSpecialCharacterExcludingSome.test(
                            customerAccountInfo.registerAddress
                              .customerCertifiedEmail
                          );
                        if (
                          customerAccountInfo.registerAddress
                            .customerCertifiedEmail.length > emailCharacterLimit
                        ) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerCertifiedEmail: EMAIL_CHARACTER_LIMIT,
                            },
                          });
                        } else if (characterCustomerAuthorizedEmailId) {
                          if (emailCustomerCertifiedEmailId) {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                customerCertifiedEmail: "",
                              },
                            });
                          } else {
                            setCustomerAccountError({
                              ...customerAccountError,
                              registerAddress: {
                                ...customerAccountError.registerAddress,
                                customerCertifiedEmail: EMAIL_VALIDATION,
                              },
                            });
                          }
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerCertifiedEmail:
                                SPECIAL_CHARACTERS_NOT_ALLOWED,
                            },
                          });
                        }
                      }
                    }}
                    errorMessage={
                      customerAccountError.registerAddress
                        .customerCertifiedEmail
                    }
                  />
                  <TextField
                    styles={TextFieldStyles}
                    label={customerAccountInfo.registerAddress.country?.toLowerCase() === "italy" 
                      ? "Customer Consignee Code*" 
                      : "Customer Consignee Code"}
                    name="CustomerConsigneeCode"
                    ariaLabel="CustomerConsigneeCode"
                    required={customerAccountInfo.registerAddress.country?.toLowerCase() === "italy"}
                    value={
                      customerAccountInfo.registerAddress.customerConsigneeCode
                    }
                    onChange={(e, customerConsigneeCode) => {
                      if (
                        isBillingChecked ||
                        isShippingByBusinessAddressChecked
                      ) {
                        // Update billing address if the checkbox is checked
                        if (isBillingChecked) {
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            billingAddress: {
                              ...customerAccountInfo.billingAddress,
                              customerConsigneeCode:
                                customerConsigneeCode || "",
                            },
                          });
                        }

                        // Update shipping address if the checkbox is checked
                        if (isShippingByBusinessAddressChecked) {
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            shippingAddress: {
                              ...customerAccountInfo.shippingAddress,
                              customerConsigneeCode:
                                customerConsigneeCode || "",
                            },
                          });
                        }
                      }
                      if (
                        customerConsigneeCode &&
                        customerConsigneeCode?.length > 0
                      ) {
                        var characterCustomerAuthorizedEmailId =
                          allowSpecialCharacterExcludingSome.test(
                            customerConsigneeCode
                          );
                        if (characterCustomerAuthorizedEmailId) {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerConsigneeCode: "",
                            },
                          });
                        } else {
                          setCustomerAccountError({
                            ...customerAccountError,
                            registerAddress: {
                              ...customerAccountError.registerAddress,
                              customerConsigneeCode:
                                SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                            },
                          });
                        }
                      } else {
                        setCustomerAccountError({
                          ...customerAccountError,
                          registerAddress: {
                            ...customerAccountError.registerAddress,
                            customerConsigneeCode: "",
                          },
                        });
                      }
                      setCustomerAccountInfo({
                        ...customerAccountInfo,
                        registerAddress: {
                          ...customerAccountInfo.registerAddress,
                          customerConsigneeCode: customerConsigneeCode || "",
                        },
                      });
                    }}
                    errorMessage={
                      customerAccountError.registerAddress.customerConsigneeCode
                    }
                  />
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack horizontal style={cardSize}>
            <Card
              styles={{
                layout: {},
                footer: { padding: "0" },
              }}
              header={<CardStandardHeader cardTitle="Billing Details" />}
            >
              <Stack horizontal tokens={{ childrenGap: 30 }}>
                <Stack verticalAlign="start" style={{ width: "47%" }}>
                  <StackItem>
                    <Checkbox
                      checked={isBillingChecked}
                      onChange={() => toggleBillingNameValue()}
                      label="Same as Business/Sold To Address"
                      styles={CheckBoxStyle}
                    />
                  </StackItem>
                </Stack>
                <Stack verticalAlign="start">
                  <StackItem>
                    <Checkbox
                      checked={isBillingContactChecked}
                      onChange={() => toggleBillingContactsNameValue()}
                      label="Same as Authorized Buyer Contact"
                      styles={CheckBoxStyle}
                    />
                  </StackItem>
                </Stack>
              </Stack>
              {isBillingChecked && isBillingContactChecked ? (
                <Stack horizontal>
                  <Stack verticalAlign="start">
                    <StackItem>
                      <Stack
                        style={{
                          color: "#727272",
                          width: "250px",
                        }}
                      >
                        <h4 style={{ color: "black" }}>Bill To</h4>
                        <p>{`${customerAccountInfo.billingAddress.street}`}</p>
                        <p>{`${customerAccountInfo?.billingAddress.city} ${customerAccountInfo?.billingAddress.state} ${customerAccountInfo.billingAddress.country}`}</p>
                        <p>{`${customerAccountInfo?.billingAddress.postalCode}`}</p>
                        <p>{`${
                          customerAccountInfo?.billingAddress.purchasingCompanyTaxId.toLocaleUpperCase() ===
                          "N/A"
                            ? customerAccountInfo?.billingAddress.purchasingCompanyTaxId.toLocaleUpperCase()
                            : customerAccountInfo?.billingAddress
                                .purchasingCompanyTaxId
                        }`}</p>
                        {billingErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                        <TextField
                          styles={TextFieldStyles}
                          label="Bill To SAP Account ID"
                          name="sapAccountIdBilling"
                          ariaLabel="Bill To SAP Account ID"
                          value={
                            customerAccountInfo.billingAddress.sapAccountId
                          }
                          onChange={(e, sapAccountIdBillingValue) => {
                            if (
                              sapAccountIdBillingValue &&
                              sapAccountIdBillingValue?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(sapAccountIdBillingValue);
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                sapAccountId: sapAccountIdBillingValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.billingAddress
                                ?.sapAccountId &&
                              customerAccountInfo?.billingAddress?.sapAccountId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(
                                  customerAccountInfo?.billingAddress
                                    ?.sapAccountId
                                );
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.sapAccountId
                          }
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                  <Stack verticalAlign="start">
                    <StackItem>
                      {" "}
                      <Stack
                        style={{
                          color: "#727272",
                          width: "100px",
                          marginLeft: "100px",
                        }}
                      >
                        <h4 style={{ color: "black" }}>Contact</h4>
                        <p>{`${customerAccountInfo.billingAddress.contacts.contactFirstName} ${customerAccountInfo.billingAddress.contacts.contactLastName}`}</p>
                        <p>{`${customerAccountInfo?.billingAddress.contacts.contactPhone}`}</p>
                        <p>{`${customerAccountInfo?.billingAddress.contacts.contactEmail}`}</p>
                        {billingContactsErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>
              ) : (
                <Stack>
                  {isBillingChecked && !isBillingContactChecked ? (
                    <Stack style={{ color: "#727272" }}>
                      <h4 style={{ color: "black" }}>Bill To</h4>
                      <p>{`${customerAccountInfo.billingAddress.street}`}</p>
                      <p>{`${customerAccountInfo?.billingAddress.city} ${customerAccountInfo?.billingAddress.state} ${customerAccountInfo.billingAddress.country}`}</p>
                      <p>{`${customerAccountInfo?.billingAddress.postalCode}`}</p>
                      <p>{`${
                        customerAccountInfo?.billingAddress.purchasingCompanyTaxId.toLocaleUpperCase() ===
                        "N/A"
                          ? customerAccountInfo?.billingAddress.purchasingCompanyTaxId.toLocaleUpperCase()
                          : customerAccountInfo?.billingAddress
                              .purchasingCompanyTaxId
                      }`}</p>
                      {billingErrorMessages.length > 0 && (
                        <p
                          style={{ color: "red" }}
                        >{`Required Fields are missing`}</p>
                      )}
                      <TextField
                        styles={TextFieldStyles}
                        label="Bill To SAP Account ID"
                        name="sapAccountIdBilling"
                        ariaLabel="Bill To SAP Account ID"
                        value={customerAccountInfo.billingAddress.sapAccountId}
                        onChange={(e, sapAccountIdBillingValue) => {
                          if (
                            sapAccountIdBillingValue &&
                            sapAccountIdBillingValue?.length > 0
                          ) {
                            var specialCharacterCustomersapAccountId =
                              numbersOnly.test(sapAccountIdBillingValue);
                            if (specialCharacterCustomersapAccountId) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  sapAccountId: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  sapAccountId: NUMBERS_ALLOWED,
                                },
                              });
                            }
                          }
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            billingAddress: {
                              ...customerAccountInfo.billingAddress,
                              sapAccountId: sapAccountIdBillingValue || "",
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerAccountInfo.billingAddress.sapAccountId &&
                            customerAccountInfo.billingAddress.sapAccountId
                              ?.length > 0
                          ) {
                            var specialCharacterCustomersapAccountId =
                              numbersOnly.test(
                                customerAccountInfo.billingAddress.sapAccountId
                              );
                            if (specialCharacterCustomersapAccountId) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  sapAccountId: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  sapAccountId: NUMBERS_ALLOWED,
                                },
                              });
                            }
                          }
                        }}
                        errorMessage={
                          customerAccountError.billingAddress.sapAccountId
                        }
                      />
                    </Stack>
                  ) : (
                    <Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label={"Billing Name"}
                          name={"billingName"}
                          ariaLabel="Billing Name"
                          required
                          value={customerAccountInfo.billingAddress.name}
                          onChange={(e, billingNameValue) => {
                            // Validation logic
                            if (
                              billingNameValue &&
                              billingNameValue?.length > 0
                            ) {
                              var specialCharacterCustomerbillingName =
                                allowSpecialCharacterExcludingSome.test(
                                  billingNameValue
                                );
                              if (specialCharacterCustomerbillingName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    name: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  name: BILLINGNAME_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                name: billingNameValue || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                name: billingNameValue || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress.name &&
                              customerAccountInfo.billingAddress.name?.length >
                                0
                            ) {
                              var specialCharacterCustomerbillingName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress.name
                                );
                              if (
                                customerAccountInfo.billingAddress.name.length >
                                companyNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    name: BILLING_NAME_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (specialCharacterCustomerbillingName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    name: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  name: BILLINGNAME_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.name
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Street (Must not be P.O. Box)"
                          name="street"
                          ariaLabel="Street (Must not be P.O. Box)"
                          required
                          value={customerAccountInfo.billingAddress.street}
                          onChange={(e, StreetValue) => {
                            // Validation logic
                            if (StreetValue && StreetValue?.length > 0) {
                              var billingAddressStreetLength =
                                customerAccountInfo.billingAddress.street
                                  .length;
                              var poBoxRegexSpecialCharacterStreetPattern =
                                allowSpecialCharacterExcludingSome.test(
                                  StreetValue
                                );
                              if (StreetValue.length <= 60) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    street: "",
                                  },
                                });
                                if (!poBoxRegexSpecialCharacterStreetPattern) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      street:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      street: "",
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    street:
                                      "Street Length should not be greater than 60 characters",
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  street: STREET_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                street: StreetValue || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                street: StreetValue || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress.street &&
                              customerAccountInfo.billingAddress.street
                                ?.length > 0
                            ) {
                              var billingAddressStreetLength =
                                customerAccountInfo.billingAddress.street
                                  .length;
                              var poBoxRegexStreetPattern = poBoxRegex.test(
                                customerAccountInfo.billingAddress.street
                              );
                              var poBoxRegexSpecialCharacterStreetPattern =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress.street
                                );
                              if (billingAddressStreetLength <= 60) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    street: "",
                                  },
                                });
                                if (poBoxRegexSpecialCharacterStreetPattern) {
                                  if (poBoxRegexStreetPattern) {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      billingAddress: {
                                        ...customerAccountError.billingAddress,
                                        street: Street_PO_BOX_VALIDATION,
                                      },
                                    });
                                  } else {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      billingAddress: {
                                        ...customerAccountError.billingAddress,
                                        street: "",
                                      },
                                    });
                                  }
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      street:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    street:
                                      "Street Length should not be greater than 60 characters",
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  street: STREET_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.street
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Zip/Postal Code"
                          name="postalCode"
                          ariaLabel="Zip/Postal Code"
                          required
                          value={customerAccountInfo.billingAddress.postalCode}
                          onChange={(e, postalCodeValue) => {
                            // Validation logic
                            if (
                              postalCodeValue &&
                              postalCodeValue?.length > 0
                            ) {
                              var specialCharacterCustomerPostalCode =
                                allowSpecialCharacterExcludingSome.test(
                                  postalCodeValue
                                );
                              if (specialCharacterCustomerPostalCode) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  postalCode: POSTALCODE_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                postalCode: postalCodeValue || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                postalCode: postalCodeValue || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress.postalCode &&
                              customerAccountInfo.billingAddress.postalCode
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerPostalCode =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress.postalCode
                                );
                              if (
                                customerAccountInfo.billingAddress.postalCode
                                  .length > postalCodeCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: POSTALCODE_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (specialCharacterCustomerPostalCode) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  postalCode: POSTALCODE_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.postalCode
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="City"
                          name="city"
                          ariaLabel="City"
                          required
                          value={customerAccountInfo.billingAddress.city}
                          onChange={(e, cityValue) => {
                            // Validation logic
                            if (cityValue && cityValue?.length > 0) {
                              var characterCustomerCity =
                                allowSpecialCharacterExcludingSome.test(
                                  cityValue
                                );
                              if (characterCustomerCity) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    city: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  city: CITY_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                city: cityValue || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                city: cityValue || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress.city &&
                              customerAccountInfo.billingAddress.city?.length >
                                0
                            ) {
                              var characterCustomerCity =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress.city
                                );
                              if (
                                customerAccountInfo.billingAddress.city.length >
                                cityCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    city: CITY_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (characterCustomerCity) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    city: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  city: CITY_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.city
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <ComboBox
                          styles={customerNewAccountComboBoxStyleAuto}
                          label="Country"
                          ariaLabel="Country"
                          options={selectedBusinessSoldToCountry}
                          required
                          selectedKey={
                            customerAccountInfo.billingAddress.country
                          }
                          onChange={(e, countryValue) => {
                            // Validation logic
                            if (countryValue && countryValue?.text.length > 0) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  country: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  country: COUNTRY_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                country: countryValue?.text.toString() || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                country: countryValue?.text.toString() || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                            const billingAddressStateList = countryWiseStateList
                              .filter(
                                (x) =>
                                  x.country.toLocaleLowerCase() ===
                                  countryValue?.text.toLocaleLowerCase()
                              )
                              .sort((a, b) => a.text.localeCompare(b.text));
                            setBillingAddressStateOptions(
                              billingAddressStateList
                            );
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.country
                          }
                        />
                        <ComboBox
                          styles={customerNewAccountComboBoxStyle}
                          label="State/Province"
                          ariaLabel="State/Province"
                          options={billingAddressStateOptions}
                          required
                          selectedKey={customerAccountInfo.billingAddress.state}
                          onChange={(e, stateValue) => {
                            // Validation logic
                            if (stateValue && stateValue?.text.length > 0) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  state: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  state: PROVINCE_REQUIRED,
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                state: stateValue?.text.toString() || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                state: stateValue?.text.toString() || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.state
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Purchasing Company Tax ID"
                          name="purchasingCompanyTaxId"
                          ariaLabel="Purchasing Company Tax ID"
                          value={
                            customerAccountInfo.billingAddress
                              .purchasingCompanyTaxId
                          }
                          onChange={(e, purchasingCompanytaxIdValue) => {
                            // Validation logic
                            if (
                              purchasingCompanytaxIdValue &&
                              purchasingCompanytaxIdValue?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingCompanyTaxId =
                                allowSpecialCharacterExcludingSome.test(
                                  purchasingCompanytaxIdValue
                                );
                              if (
                                specialCharacterCustomerPurchasingCompanyTaxId
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    purchasingCompanyTaxId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    purchasingCompanyTaxId:
                                      SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  purchasingCompanyTaxId: "",
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                purchasingCompanyTaxId:
                                  purchasingCompanytaxIdValue?.toLocaleLowerCase() ===
                                  "n/a"
                                    ? "N/A"
                                    : purchasingCompanytaxIdValue || "",
                              },
                            };

                            // Update shipping address if the checkbox is checked
                            if (isShippingChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                shipmentCompanyTaxId:
                                  purchasingCompanytaxIdValue?.toLocaleLowerCase() ===
                                  "n/a"
                                    ? "N/A"
                                    : purchasingCompanytaxIdValue || "",
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress
                                .purchasingCompanyTaxId &&
                              customerAccountInfo.billingAddress
                                .purchasingCompanyTaxId?.length > 0
                            ) {
                              var specialCharacterCustomerPurchasingCompanyTaxId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress
                                    .purchasingCompanyTaxId
                                );
                              if (
                                customerAccountInfo.billingAddress
                                  .purchasingCompanyTaxId.length >
                                companyTaxIdCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    purchasingCompanyTaxId:
                                      COMPANY_TAXID_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (
                                specialCharacterCustomerPurchasingCompanyTaxId
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    purchasingCompanyTaxId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    purchasingCompanyTaxId:
                                      SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  purchasingCompanyTaxId: "",
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress
                              .purchasingCompanyTaxId
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Bill To SAP Account ID"
                          name="sapAccountIdBilling"
                          ariaLabel="Bill To SAP Account ID"
                          value={
                            customerAccountInfo.billingAddress.sapAccountId
                          }
                          onChange={(e, sapAccountIdBillingValue) => {
                            if (
                              sapAccountIdBillingValue &&
                              sapAccountIdBillingValue?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(sapAccountIdBillingValue);
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                sapAccountId: sapAccountIdBillingValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress.sapAccountId &&
                              customerAccountInfo.billingAddress.sapAccountId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(
                                  customerAccountInfo.billingAddress
                                    .sapAccountId
                                );
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.sapAccountId
                          }
                        />
                      </Stack>
                    </Stack>
                  )}
                  <Stack>
                    <h4 style={{ color: "#727272", marginBottom: "-5px" }}>
                      Contacts
                    </h4>
                  </Stack>
                  <Separator />
                  {isBillingContactChecked && !isBillingChecked ? (
                    <Stack style={{ color: "#727272" }}>
                      <h4 style={{ color: "black" }}>Contact</h4>
                      <p>{`${customerAccountInfo.billingAddress.contacts.contactFirstName} ${customerAccountInfo.billingAddress.contacts.contactLastName}`}</p>
                      <p>{`${customerAccountInfo?.billingAddress.contacts.contactPhone}`}</p>
                      <p>{`${customerAccountInfo?.billingAddress.contacts.contactEmail}`}</p>
                      {billingContactsErrorMessages.length > 0 && (
                        <p
                          style={{ color: "red" }}
                        >{`Required Fields are missing`}</p>
                      )}
                    </Stack>
                  ) : (
                    <Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="First Name"
                          name="firstName"
                          required
                          ariaLabel="First Name"
                          value={
                            customerAccountInfo.billingAddress?.contacts
                              ?.contactFirstName
                          }
                          onChange={(e, contactFirstNameValue) => {
                            // Validation logic
                            if (
                              contactFirstNameValue &&
                              contactFirstNameValue?.length > 0
                            ) {
                              var characterCustomerContactFirstName =
                                allowSpecialCharacterExcludingSome.test(
                                  contactFirstNameValue
                                );
                              if (characterCustomerContactFirstName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactFirstName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactFirstName:
                                      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                                  },
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                contacts: {
                                  ...customerAccountInfo.billingAddress
                                    .contacts,
                                  contactFirstName: contactFirstNameValue || "",
                                },
                              },
                            };

                            // Update shipping contact if the checkbox is checked
                            if (isShippingContactChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                contacts: {
                                  ...updatedAccountInfo.shippingAddress
                                    .contacts,
                                  contactFirstName: contactFirstNameValue || "",
                                },
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress?.contacts
                                ?.contactFirstName &&
                              customerAccountInfo.billingAddress?.contacts
                                ?.contactFirstName?.length > 0
                            ) {
                              var characterCustomerContactFirstName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress?.contacts
                                    ?.contactFirstName
                                );
                              if (
                                customerAccountInfo.billingAddress?.contacts
                                  ?.contactFirstName.length >
                                contactNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactFirstName:
                                        CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (characterCustomerContactFirstName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactFirstName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactFirstName:
                                      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.contacts
                              .contactFirstName
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Last Name"
                          name="lastName"
                          ariaLabel="Last Name"
                          required
                          value={
                            customerAccountInfo.billingAddress?.contacts
                              ?.contactLastName
                          }
                          onChange={(e, contactlastNameValue) => {
                            // Validation logic
                            if (
                              contactlastNameValue &&
                              contactlastNameValue?.length > 0
                            ) {
                              var characterCustomerContactLastName =
                                allowSpecialCharacterExcludingSome.test(
                                  contactlastNameValue
                                );
                              if (characterCustomerContactLastName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactLastName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactLastName:
                                      AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                                  },
                                },
                              });
                            }

                            // Single state update with all changes
                            const updatedAccountInfo = {
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                contacts: {
                                  ...customerAccountInfo.billingAddress
                                    .contacts,
                                  contactLastName: contactlastNameValue || "",
                                },
                              },
                            };

                            // Update shipping contact if the checkbox is checked
                            if (isShippingContactChecked) {
                              updatedAccountInfo.shippingAddress = {
                                ...updatedAccountInfo.shippingAddress,
                                contacts: {
                                  ...updatedAccountInfo.shippingAddress
                                    .contacts,
                                  contactLastName: contactlastNameValue || "",
                                },
                              };
                            }

                            setCustomerAccountInfo(updatedAccountInfo);
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.billingAddress?.contacts
                                ?.contactLastName &&
                              customerAccountInfo.billingAddress?.contacts
                                ?.contactLastName?.length > 0
                            ) {
                              var characterCustomerContactLastName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.billingAddress?.contacts
                                    ?.contactLastName
                                );
                              if (
                                customerAccountInfo.billingAddress?.contacts
                                  ?.contactLastName.length >
                                contactNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactLastName:
                                        CONTACT_LASTNAME_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (characterCustomerContactLastName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactLastName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactLastName:
                                      AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.contacts
                              .contactLastName
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Phone"
                          name="billingPhone"
                          ariaLabel="Phone"
                          required
                          value={
                            customerAccountInfo.billingAddress.contacts
                              .contactPhone
                          }
                          onChange={(e, contactPhoneValue) => {
                            if (isShippingContactChecked) {
                              // Update shipping contact if the checkbox is checked
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                shippingAddress: {
                                  ...customerAccountInfo.shippingAddress,
                                  contacts: {
                                    ...customerAccountInfo.shippingAddress
                                      .contacts,
                                    contactPhone: contactPhoneValue || "",
                                  },
                                },
                              });
                            }
                            if (
                              contactPhoneValue &&
                              contactPhoneValue?.length > 0
                            ) {
                              var characterCustomerContactPhone =
                                contactNumberRegex.test(contactPhoneValue);
                              if (characterCustomerContactPhone) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactPhone: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                contacts: {
                                  ...customerAccountInfo.billingAddress
                                    .contacts,
                                  contactPhone: contactPhoneValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.billingAddress?.contacts
                                ?.contactPhone &&
                              customerAccountInfo?.billingAddress?.contacts
                                ?.contactPhone?.length > 0
                            ) {
                              var checkLength = phoneNumberRegex.test(
                                customerAccountInfo?.billingAddress?.contacts
                                  ?.contactPhone
                              );
                              var characterCustomerContactPhone =
                                contactNumberRegex.test(
                                  customerAccountInfo?.billingAddress?.contacts
                                    ?.contactPhone
                                );
                              if (characterCustomerContactPhone) {
                                if (!checkLength) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      contacts: {
                                        ...customerAccountError.billingAddress
                                          .contacts,
                                        contactPhone: INVALID_PHONENUMBER,
                                      },
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      contacts: {
                                        ...customerAccountError.billingAddress
                                          .contacts,
                                        contactPhone: "",
                                      },
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.contacts
                              .contactPhone
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Email"
                          name="contactEmail"
                          ariaLabel="Email"
                          required
                          value={
                            customerAccountInfo.billingAddress.contacts
                              .contactEmail
                          }
                          onChange={(e, contactEmailValue) => {
                            if (isShippingContactChecked) {
                              // Update shipping contact if the checkbox is checked
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                shippingAddress: {
                                  ...customerAccountInfo.shippingAddress,
                                  contacts: {
                                    ...customerAccountInfo.shippingAddress
                                      .contacts,
                                    contactEmail: contactEmailValue || "",
                                  },
                                },
                              });
                            }
                            if (
                              contactEmailValue &&
                              contactEmailValue?.length > 0
                            ) {
                              var characterCustomerAuthorizedEmailId =
                                allowSpecialCharacterExcludingSome.test(
                                  contactEmailValue
                                );
                              if (characterCustomerAuthorizedEmailId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactEmail: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactEmail:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactEmail:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              billingAddress: {
                                ...customerAccountInfo.billingAddress,
                                contacts: {
                                  ...customerAccountInfo.billingAddress
                                    .contacts,
                                  contactEmail: contactEmailValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.billingAddress?.contacts
                                ?.contactEmail &&
                              customerAccountInfo?.billingAddress?.contacts
                                ?.contactEmail?.length > 0
                            ) {
                              var characterCustomerAuthorizedEmailId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.billingAddress?.contacts
                                    ?.contactEmail
                                );
                              var customerAuthorizedEmailId = emailRegex.test(
                                customerAccountInfo?.billingAddress?.contacts
                                  ?.contactEmail
                              );
                              if (
                                customerAccountInfo?.billingAddress?.contacts
                                  ?.contactEmail.length > emailCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactEmail: EMAIL_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (characterCustomerAuthorizedEmailId) {
                                if (customerAuthorizedEmailId) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      contacts: {
                                        ...customerAccountError.billingAddress
                                          .contacts,
                                        contactEmail: "",
                                      },
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    billingAddress: {
                                      ...customerAccountError.billingAddress,
                                      contacts: {
                                        ...customerAccountError.billingAddress
                                          .contacts,
                                        contactEmail: EMAIL_VALIDATION,
                                      },
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  billingAddress: {
                                    ...customerAccountError.billingAddress,
                                    contacts: {
                                      ...customerAccountError.billingAddress
                                        .contacts,
                                      contactEmail:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                billingAddress: {
                                  ...customerAccountError.billingAddress,
                                  contacts: {
                                    ...customerAccountError.billingAddress
                                      .contacts,
                                    contactEmail:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.billingAddress.contacts
                              .contactEmail
                          }
                        />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              )}
            </Card>
          </Stack>
          {customerAccountInfo.billingAddress.country.toLocaleUpperCase() ===
            "CHINA" && (
            <Stack horizontal style={cardSize}>
              <Card
                styles={{
                  layout: {},
                  footer: { padding: "0" },
                  root: {
                    paddingBottom: "20px",
                  },
                }}
                header={<CardStandardHeader cardTitle="Fapiao" />}
              >
                <Stack horizontal tokens={{ childrenGap: 30 }}>
                  <Stack verticalAlign="start" style={{ width: "47%" }}>
                    <StackItem>
                      <Checkbox
                        onChange={() => toggleFapiaoNameValue()}
                        label="Same as Billing Address"
                        styles={CheckBoxStyle}
                        ariaLabel="Same as Billing Address"
                      />
                    </StackItem>
                  </Stack>
                  <Stack verticalAlign="start">
                    <StackItem>
                      <Checkbox
                        onChange={() => toggleFapiaoContactsNameValue()}
                        label="Same as Billing Phone"
                        ariaLabel="Same as Billing Phone"
                        styles={CheckBoxStyle}
                      />
                    </StackItem>
                  </Stack>
                </Stack>
                {isFapiaoChecked && isfapiaoContactChecked ? (
                  <Stack horizontal>
                    <Stack verticalAlign="start">
                      <StackItem>
                        <Stack
                          style={{
                            color: "#727272",
                            width: "250px",
                          }}
                        >
                          <h4 style={{ color: "black" }}>Fapiao</h4>
                          <p>{`${customerAccountInfo.fapiaoAddress.street}`}</p>
                          <p>{`${customerAccountInfo?.fapiaoAddress.city} ${customerAccountInfo?.fapiaoAddress.state} ${customerAccountInfo.fapiaoAddress.country}`}</p>
                          <p>{`${customerAccountInfo?.fapiaoAddress.postalCode}`}</p>
                          {fapiaoErrorMessages.length > 0 && (
                            <p
                              style={{ color: "red" }}
                            >{`Required Fields are missing`}</p>
                          )}
                        </Stack>
                      </StackItem>
                    </Stack>
                    <Stack verticalAlign="start">
                      <StackItem>
                        {" "}
                        <Stack
                          style={{
                            color: "#727272",
                            width: "100px",
                            marginLeft: "100px",
                          }}
                        >
                          <h4 style={{ color: "black" }}>Contact</h4>
                          <p>{`${customerAccountInfo?.fapiaoAddress.contacts.contactPhone}`}</p>
                          {fapiaoContactsErrorMessages.length > 0 && (
                            <p
                              style={{ color: "red" }}
                            >{`Required Fields are missing`}</p>
                          )}
                        </Stack>
                      </StackItem>
                    </Stack>
                  </Stack>
                ) : (
                  <Stack>
                    {isFapiaoChecked && !isfapiaoContactChecked ? (
                      <Stack style={{ color: "#727272" }}>
                        <h4 style={{ color: "black" }}>Fapiao</h4>
                        <p>{`${customerAccountInfo.fapiaoAddress.street}`}</p>
                        <p>{`${customerAccountInfo?.fapiaoAddress.city} ${customerAccountInfo?.fapiaoAddress.state} ${customerAccountInfo.fapiaoAddress.country}`}</p>
                        <p>{`${customerAccountInfo?.fapiaoAddress.postalCode}`}</p>
                        {fapiaoErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                      </Stack>
                    ) : (
                      <Stack>
                        <Stack horizontal tokens={{ childrenGap: 30 }}>
                          <TextField
                            styles={TextFieldStyles}
                            label={"Name"}
                            name={"fapioName"}
                            ariaLabel="Name"
                            required
                            value={customerAccountInfo.fapiaoAddress.name}
                            onChange={(e, fapioNameValue) => {
                              if (
                                fapioNameValue &&
                                fapioNameValue?.length > 0
                              ) {
                                var specialCharacterCustomerShippingName =
                                  allowSpecialCharacterExcludingSome.test(
                                    fapioNameValue
                                  );
                                if (specialCharacterCustomerShippingName) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      name: "",
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    name: BILLINGNAME_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  name: fapioNameValue || "",
                                },
                              });
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.name
                            }
                          />
                          <TextField
                            styles={TextFieldStyles}
                            label="Street (Must not be P.O. Box)"
                            name="street"
                            ariaLabel="Street (Must not be P.O. Box)"
                            required
                            value={customerAccountInfo.fapiaoAddress.street}
                            onChange={(e, StreetValue) => {
                              if (StreetValue && StreetValue?.length > 0) {
                                var fapiaoAddressStreetLength =
                                  StreetValue.length;
                                var poBoxRegexStreetPattern =
                                  poBoxRegex.test(StreetValue);
                                var poBoxRegexSpecialCharacterStreetPattern =
                                  allowSpecialCharacterExcludingSome.test(
                                    StreetValue
                                  );
                                if (fapiaoAddressStreetLength <= 60) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      street: "",
                                    },
                                  });
                                  if (
                                    poBoxRegexStreetPattern ||
                                    !poBoxRegexSpecialCharacterStreetPattern
                                  ) {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      fapiaoAddress: {
                                        ...customerAccountError.billingAddress,
                                        street: Street_PO_BOX_VALIDATION,
                                      },
                                    });
                                  } else {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      fapiaoAddress: {
                                        ...customerAccountError.registerAddress,
                                        street: "",
                                      },
                                    });
                                  }
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      street:
                                        "Street Length should not be greater than 60 characters",
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    street: STREET_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  street: StreetValue || "",
                                },
                              });
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.street
                            }
                          />
                        </Stack>
                        <Stack horizontal tokens={{ childrenGap: 30 }}>
                          <TextField
                            styles={TextFieldStyles}
                            label="Zip/PostalCode"
                            name="postalCode"
                            ariaLabel="Zip/PostalCode"
                            required
                            value={customerAccountInfo.fapiaoAddress.postalCode}
                            onChange={(e, postalValue) => {
                              if (postalValue && postalValue?.length > 0) {
                                var characterCustomerZip =
                                  allowCharactersAndSpecialSymbols.test(
                                    postalValue
                                  );
                                if (characterCustomerZip) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      postalCode: "",
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      postalCode:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    postalCode: CITY_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  postalCode: postalValue || "",
                                },
                              });
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.postalCode
                            }
                          />
                          <TextField
                            styles={TextFieldStyles}
                            label="City"
                            name="city"
                            ariaLabel="City"
                            required
                            value={customerAccountInfo.fapiaoAddress.city}
                            onChange={(e, cityValue) => {
                              if (cityValue && cityValue?.length > 0) {
                                var characterCustomerCity =
                                  allowCharactersAndSpecialSymbols.test(
                                    cityValue
                                  );
                                if (characterCustomerCity) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      city: "",
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    fapiaoAddress: {
                                      ...customerAccountError.fapiaoAddress,
                                      city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    city: CITY_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  city: cityValue || "",
                                },
                              });
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.city
                            }
                          />
                        </Stack>
                        <Stack horizontal tokens={{ childrenGap: 30 }}>
                          <ComboBox
                            styles={customerNewAccountComboBoxStyle}
                            label="Country"
                            ariaLabel="Country"
                            allowFreeInput
                            options={regionWiseCountry}
                            required
                            selectedKey={
                              customerAccountInfo.fapiaoAddress.country
                            }
                            onChange={(e, countryValue) => {
                              if (
                                countryValue &&
                                countryValue?.text.length > 0
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    country: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    country: COUNTRY_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  country: countryValue?.text.toString() || "",
                                },
                              });
                              const fapioAddressStateList = countryWiseStateList
                                .filter(
                                  (x) =>
                                    x.country.toLocaleLowerCase() ===
                                    countryValue?.text.toLocaleLowerCase()
                                )
                                .sort((a, b) => a.text.localeCompare(b.text));
                              setFapioAddressStateOptions(
                                fapioAddressStateList
                              );
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.country
                            }
                          />
                          <ComboBox
                            styles={customerNewAccountComboBoxStyle}
                            label="State/Province"
                            ariaLabel="State/Province"
                            options={fapioAddressStateOptions}
                            required
                            selectedKey={
                              customerAccountInfo.fapiaoAddress.state
                            }
                            onChange={(e, stateValue) => {
                              if (stateValue && stateValue?.text.length > 0) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    state: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    state: STATE_REQUIRED,
                                  },
                                });
                              }
                              setCustomerAccountInfo({
                                ...customerAccountInfo,
                                fapiaoAddress: {
                                  ...customerAccountInfo.fapiaoAddress,
                                  state: stateValue?.text.toString() || "",
                                },
                              });
                            }}
                            errorMessage={
                              customerAccountError.fapiaoAddress.state
                            }
                          />
                        </Stack>
                      </Stack>
                    )}
                    {isfapiaoContactChecked && !isFapiaoChecked ? (
                      <Stack style={{ color: "#727272" }}>
                        <h4 style={{ color: "black" }}>Contact</h4>
                        <p>{`${customerAccountInfo?.fapiaoAddress.contacts.contactPhone}`}</p>
                        {fapiaoContactsErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                      </Stack>
                    ) : (
                      <Stack>
                        <TextField
                          styles={TextFieldStyles}
                          label="Phone"
                          name="fapioPhone"
                          ariaLabel="Phone"
                          required
                          value={
                            customerAccountInfo.fapiaoAddress.contacts
                              .contactPhone
                          }
                          onChange={(e, contactPhoneValue) => {
                            if (
                              contactPhoneValue &&
                              contactPhoneValue?.length > 0
                            ) {
                              var characterCustomerContactPhone =
                                phoneNumberRegex.test(contactPhoneValue);
                              if (characterCustomerContactPhone) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    contacts: {
                                      ...customerAccountError.fapiaoAddress
                                        .contacts,
                                      contactPhone: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  fapiaoAddress: {
                                    ...customerAccountError.fapiaoAddress,
                                    contacts: {
                                      ...customerAccountError.fapiaoAddress
                                        .contacts,
                                      contactPhone: INVALID_PHONENUMBER,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                fapiaoAddress: {
                                  ...customerAccountError.fapiaoAddress,
                                  contacts: {
                                    ...customerAccountError.fapiaoAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              fapiaoAddress: {
                                ...customerAccountInfo.fapiaoAddress,
                                contacts: {
                                  ...customerAccountInfo.fapiaoAddress.contacts,
                                  contactPhone: contactPhoneValue || "",
                                },
                              },
                            });
                          }}
                          errorMessage={
                            customerAccountError.fapiaoAddress.contacts
                              .contactPhone
                          }
                        />
                      </Stack>
                    )}
                  </Stack>
                )}
              </Card>
            </Stack>
          )}
          <Stack horizontal style={cardSize}>
            <Card
              styles={{
                footer: { padding: "0" },
                root: { paddingBottom: "20px" },
              }}
              header={<CardStandardHeader cardTitle="Shipping Details" />}
            >
              <Stack horizontal tokens={{ childrenGap: 30 }}>
                <Stack verticalAlign="start" style={{ width: "47%" }}>
                  <StackItem>
                    <Checkbox
                      checked={isShippingByBusinessAddressChecked}
                      onChange={() =>
                        toggleShippingNameValueByBusinessAddress()
                      }
                      label="Same as Business/Sold To Address"
                      ariaLabel="Same as Business/Sold To Address"
                      styles={CheckBoxStyle}
                      disabled={isShippingChecked}
                    />
                  </StackItem>
                </Stack>
                <Stack verticalAlign="start">
                  <StackItem>
                    <Checkbox
                      checked={isShippingByBusinessContactChecked}
                      onChange={() =>
                        toggleShippingContactsNameValueByBusinessContact()
                      }
                      label="Same as Authorized Buyer Contact"
                      ariaLabel="Same as Authorized Buyer Contact"
                      styles={CheckBoxStyle}
                      disabled={isShippingContactChecked}
                    />
                  </StackItem>
                </Stack>
              </Stack>
              <Stack horizontal tokens={{ childrenGap: 30 }}>
                <Stack verticalAlign="start" style={{ width: "47%" }}>
                  <StackItem>
                    <Checkbox
                      checked={isShippingChecked}
                      onChange={() => toggleShippingNameValue()}
                      label="Same as Billing Address"
                      ariaLabel="Same as Billing Address"
                      styles={CheckBoxStyle}
                      disabled={isShippingByBusinessAddressChecked}
                    />
                  </StackItem>
                </Stack>
                <Stack verticalAlign="start">
                  <StackItem>
                    <Checkbox
                      checked={isShippingContactChecked}
                      onChange={() => toggleShippingContactsNameValue()}
                      label="Same as Billing Contact"
                      ariaLabel="Same as Billing Contact"
                      styles={CheckBoxStyle}
                      disabled={isShippingByBusinessContactChecked}
                    />
                  </StackItem>
                </Stack>
              </Stack>
              {(isShippingChecked || isShippingByBusinessAddressChecked) &&
              (isShippingContactChecked ||
                isShippingByBusinessContactChecked) ? (
                <Stack horizontal>
                  <Stack verticalAlign="start">
                    <StackItem>
                      <Stack
                        style={{
                          color: "#727272",
                          width: "250px",
                        }}
                      >
                        <h4 style={{ color: "black" }}>Ship To</h4>
                        <p>{`${customerAccountInfo.shippingAddress.street}`}</p>
                        <p>{`${customerAccountInfo?.shippingAddress.city} ${customerAccountInfo?.shippingAddress.state} ${customerAccountInfo.shippingAddress.country}`}</p>
                        <p>{`${customerAccountInfo?.shippingAddress.postalCode}`}</p>
                        <p>{`${
                          customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.toLocaleUpperCase() ===
                          "N/A"
                            ? customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.toLocaleUpperCase()
                            : customerAccountInfo?.shippingAddress
                                .shipmentCompanyTaxId
                        }`}</p>
                        {shippingErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                        <TextField
                          styles={TextFieldStyles}
                          label="Ship To SAP Account ID"
                          ariaLabel="Ship To SAP Account ID"
                          name="sapAccountIdShipping"
                          value={
                            customerAccountInfo.shippingAddress.sapAccountId
                          }
                          onChange={(e, sapAccountIdShippingValue) => {
                            if (
                              sapAccountIdShippingValue &&
                              sapAccountIdShippingValue?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(sapAccountIdShippingValue);
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                sapAccountId: sapAccountIdShippingValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress
                                ?.sapAccountId &&
                              customerAccountInfo?.shippingAddress?.sapAccountId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(
                                  customerAccountInfo?.shippingAddress
                                    ?.sapAccountId
                                );
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.sapAccountId
                          }
                        />
                      </Stack>
                    </StackItem>
                  </Stack>
                  <Stack verticalAlign="start">
                    <StackItem>
                      {" "}
                      <Stack
                        style={{
                          color: "#727272",
                          width: "100px",
                          marginLeft: "100px",
                        }}
                      >
                        <h4 style={{ color: "black" }}>Contact</h4>
                        <p>{`${customerAccountInfo.shippingAddress.contacts.contactFirstName} ${customerAccountInfo.shippingAddress.contacts.contactLastName}`}</p>
                        <p>{`${customerAccountInfo?.shippingAddress.contacts.contactPhone}`}</p>
                        <p>{`${customerAccountInfo?.shippingAddress.contacts.contactEmail}`}</p>
                        {shippingContactsErrorMessages.length > 0 && (
                          <p
                            style={{ color: "red" }}
                          >{`Required Fields are missing`}</p>
                        )}
                      </Stack>
                    </StackItem>
                  </Stack>
                </Stack>
              ) : (
                <Stack>
                  {(isShippingChecked || isShippingByBusinessAddressChecked) &&
                  (!isShippingContactChecked ||
                    !isShippingByBusinessContactChecked) ? (
                    <Stack style={{ color: "#727272" }}>
                      <h4 style={{ color: "black" }}>Ship To</h4>
                      <p>{`${customerAccountInfo.shippingAddress.street}`}</p>
                      <p>{`${customerAccountInfo?.shippingAddress.city} ${customerAccountInfo?.shippingAddress.state} ${customerAccountInfo.shippingAddress.country}`}</p>
                      <p>{`${customerAccountInfo?.shippingAddress.postalCode}`}</p>
                      <p>{`${
                        customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.toLocaleUpperCase() ===
                        "N/A"
                          ? customerAccountInfo?.shippingAddress.shipmentCompanyTaxId.toLocaleUpperCase()
                          : customerAccountInfo?.shippingAddress
                              .shipmentCompanyTaxId
                      }`}</p>
                      {shippingErrorMessages.length > 0 && (
                        <p
                          style={{ color: "red" }}
                        >{`Required Fields are missing`}</p>
                      )}
                      <TextField
                        styles={TextFieldStyles}
                        label="Ship To SAP Account ID"
                        name="sapAccountIdShipping"
                        ariaLabel="Ship To SAP Account ID"
                        value={customerAccountInfo.shippingAddress.sapAccountId}
                        onChange={(e, sapAccountIdShippingValue) => {
                          if (
                            sapAccountIdShippingValue &&
                            sapAccountIdShippingValue?.length > 0
                          ) {
                            var specialCharacterCustomersapAccountId =
                              numbersOnly.test(sapAccountIdShippingValue);
                            if (specialCharacterCustomersapAccountId) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  sapAccountId: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  sapAccountId: NUMBERS_ALLOWED,
                                },
                              });
                            }
                          }
                          setCustomerAccountInfo({
                            ...customerAccountInfo,
                            shippingAddress: {
                              ...customerAccountInfo.shippingAddress,
                              sapAccountId: sapAccountIdShippingValue || "",
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            customerAccountInfo?.shippingAddress
                              ?.sapAccountId &&
                            customerAccountInfo?.shippingAddress?.sapAccountId
                              ?.length > 0
                          ) {
                            var specialCharacterCustomersapAccountId =
                              numbersOnly.test(
                                customerAccountInfo?.shippingAddress
                                  ?.sapAccountId
                              );
                            if (specialCharacterCustomersapAccountId) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  sapAccountId: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  sapAccountId: NUMBERS_ALLOWED,
                                },
                              });
                            }
                          }
                        }}
                        errorMessage={
                          customerAccountError.shippingAddress.sapAccountId
                        }
                      />
                    </Stack>
                  ) : (
                    <Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label={"Shipping Name"}
                          name={"shippingName"}
                          ariaLabel="Shipping Name"
                          required
                          value={customerAccountInfo.shippingAddress.name}
                          onChange={(e, shippingNameValue) => {
                            if (
                              shippingNameValue &&
                              shippingNameValue?.length > 0
                            ) {
                              var specialCharacterCustomerShippingName =
                                allowSpecialCharacterExcludingSome.test(
                                  shippingNameValue
                                );
                              if (specialCharacterCustomerShippingName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    name: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  name: BILLINGNAME_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                name: shippingNameValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress?.name &&
                              customerAccountInfo?.shippingAddress?.name
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerShippingName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.shippingAddress?.name
                                );
                              if (
                                customerAccountInfo?.shippingAddress?.name
                                  ?.length > contactNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    name: SHIPPING_NAME_CHARACTER_LIMIT,
                                  },
                                });
                              }
                              if (specialCharacterCustomerShippingName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    name: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    name: SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  name: BILLINGNAME_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.name
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Street (Must not be P.O. Box)"
                          ariaLabel="Street (Must not be P.O. Box)"
                          name="street"
                          required
                          value={customerAccountInfo.shippingAddress.street}
                          onChange={(e, StreetValue) => {
                            if (StreetValue && StreetValue?.length > 0) {
                              var shippingAddressStreetLength =
                                StreetValue.length;
                              var poBoxRegexSpecialCharacterStreetPattern =
                                allowSpecialCharacterExcludingSome.test(
                                  StreetValue
                                );
                              if (shippingAddressStreetLength <= 60) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    street: "",
                                  },
                                });
                                if (!poBoxRegexSpecialCharacterStreetPattern) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      street: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      street: "",
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    street:
                                      "Street Length should not be greater than 60 characters",
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  street: STREET_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                street: StreetValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress?.street &&
                              customerAccountInfo?.shippingAddress?.street
                                ?.length > 0
                            ) {
                              var shippingAddressStreetLength =
                                customerAccountInfo?.shippingAddress?.street
                                  .length;
                              var poBoxRegexStreetPattern = poBoxRegex.test(
                                customerAccountInfo?.shippingAddress?.street
                              );
                              var poBoxRegexSpecialCharacterStreetPattern =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.shippingAddress?.street
                                );
                              if (shippingAddressStreetLength <= 60) {
                                if (poBoxRegexSpecialCharacterStreetPattern) {
                                  if (poBoxRegexStreetPattern) {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      shippingAddress: {
                                        ...customerAccountError.shippingAddress,
                                        street: Street_PO_BOX_VALIDATION,
                                      },
                                    });
                                  } else {
                                    setCustomerAccountError({
                                      ...customerAccountError,
                                      shippingAddress: {
                                        ...customerAccountError.shippingAddress,
                                        street: "",
                                      },
                                    });
                                  }
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      street: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    street:
                                      "Street Length should not be greater than 60 characters",
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  street: STREET_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.street
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Zip/Postal Code"
                          ariaLabel="Zip/Postal Code"
                          name="postalCode"
                          required
                          value={customerAccountInfo.shippingAddress.postalCode}
                          onChange={(e, postalCodeValue) => {
                            if (
                              postalCodeValue &&
                              postalCodeValue?.length > 0
                            ) {
                              var specialCharacterCustomerPostalCode =
                                allowSpecialCharacterExcludingSome.test(
                                  postalCodeValue
                                );
                              if (specialCharacterCustomerPostalCode) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    postalCode: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  postalCode: POSTALCODE_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                postalCode: postalCodeValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress
                                ?.postalCode &&
                              customerAccountInfo?.shippingAddress?.postalCode
                                ?.length > 0
                            ) {
                              var specialCharacterCustomerPostalCode =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.shippingAddress
                                    ?.postalCode
                                );
                              if (
                                customerAccountInfo?.shippingAddress?.postalCode
                                  .length > postalCodeCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.billingAddress,
                                    postalCode: POSTALCODE_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (specialCharacterCustomerPostalCode) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    postalCode: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    postalCode: SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  postalCode: POSTALCODE_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.postalCode
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="City"
                          ariaLabel="City"
                          name="city"
                          required
                          value={customerAccountInfo.shippingAddress.city}
                          onChange={(e, cityValue) => {
                            if (cityValue && cityValue?.length > 0) {
                              var characterCustomerCity =
                                allowSpecialCharacterExcludingSome.test(
                                  cityValue
                                );
                              if (characterCustomerCity) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    city: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  city: CITY_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                city: cityValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress?.city &&
                              customerAccountInfo?.shippingAddress?.city
                                ?.length > 0
                            ) {
                              var characterCustomerCity =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.shippingAddress?.city
                                );
                              if (
                                customerAccountInfo?.shippingAddress?.city
                                  ?.length > cityCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    city: CITY_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (characterCustomerCity) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    city: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    city: CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  city: CITY_REQUIRED,
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.city
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <ComboBox
                          styles={customerNewAccountComboBoxStyleAuto}
                          label="Country"
                          ariaLabel="Country"
                          options={selectedBusinessSoldToCountry}
                          required
                          selectedKey={
                            customerAccountInfo.shippingAddress.country
                          }
                          onChange={(e, countryValue) => {
                            if (countryValue && countryValue?.text.length > 0) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  country: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  country: COUNTRY_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                country: countryValue?.text.toString() || "",
                              },
                            });
                            const shippingAddressStateList =
                              countryWiseStateList
                                .filter(
                                  (x) =>
                                    x.country.toLocaleLowerCase() ===
                                    countryValue?.text.toLocaleLowerCase()
                                )
                                .sort((a, b) => a.text.localeCompare(b.text));
                            setShippingAddressStateOptions(
                              shippingAddressStateList
                            );
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.country
                          }
                        />
                        <ComboBox
                          styles={customerNewAccountComboBoxStyle}
                          label="State/Province"
                          ariaLabel="State/Province"
                          options={shippingAddressStateOptions}
                          required
                          selectedKey={
                            customerAccountInfo.shippingAddress.state
                          }
                          onChange={(e, stateValue) => {
                            if (stateValue && stateValue?.text.length > 0) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  state: "",
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  state: STATE_REQUIRED,
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                state: stateValue?.text.toString() || "",
                              },
                            });
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.state
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Shipment Company Tax ID"
                          name="shippingCompanyTaxId"
                          ariaLabel="Shipment Company Tax ID"
                          value={
                            customerAccountInfo.shippingAddress
                              .shipmentCompanyTaxId
                          }
                          onChange={(e, shippingCompanytaxIdValue) => {
                            if (
                              shippingCompanytaxIdValue &&
                              shippingCompanytaxIdValue?.length > 0
                            ) {
                              var specialCharacterCustomerShippingCompanyTaxId =
                                allowSpecialCharacterExcludingSome.test(
                                  shippingCompanytaxIdValue
                                );
                              if (
                                specialCharacterCustomerShippingCompanyTaxId
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    shipmentCompanyTaxId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    shipmentCompanyTaxId:
                                      SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  shipmentCompanyTaxId: "",
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                shipmentCompanyTaxId:
                                  shippingCompanytaxIdValue?.toLocaleLowerCase() ===
                                  "n/a"
                                    ? "N/A"
                                    : shippingCompanytaxIdValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress
                                ?.shipmentCompanyTaxId &&
                              customerAccountInfo?.shippingAddress
                                ?.shipmentCompanyTaxId?.length > 0
                            ) {
                              var specialCharacterCustomerShippingCompanyTaxId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo?.shippingAddress
                                    ?.shipmentCompanyTaxId
                                );
                              if (
                                customerAccountInfo?.shippingAddress
                                  ?.shipmentCompanyTaxId.length >
                                companyTaxIdCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    shipmentCompanyTaxId:
                                      COMPANY_TAXID_CHARACTER_LIMIT,
                                  },
                                });
                              } else if (
                                specialCharacterCustomerShippingCompanyTaxId
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    shipmentCompanyTaxId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    shipmentCompanyTaxId:
                                      SPECIAL_CHARACTERS_NOT_ALLOWED,
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  shipmentCompanyTaxId: "",
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress
                              .shipmentCompanyTaxId
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Ship To SAP Account ID"
                          name="sapAccountIdShipping"
                          ariaLabel="Ship To SAP Account ID"
                          value={
                            customerAccountInfo.shippingAddress.sapAccountId
                          }
                          onChange={(e, sapAccountIdShippingValue) => {
                            if (
                              sapAccountIdShippingValue &&
                              sapAccountIdShippingValue?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(sapAccountIdShippingValue);
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                sapAccountId: sapAccountIdShippingValue || "",
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo?.shippingAddress
                                ?.sapAccountId &&
                              customerAccountInfo?.shippingAddress?.sapAccountId
                                ?.length > 0
                            ) {
                              var specialCharacterCustomersapAccountId =
                                numbersOnly.test(
                                  customerAccountInfo?.shippingAddress
                                    ?.sapAccountId
                                );
                              if (specialCharacterCustomersapAccountId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: "",
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    sapAccountId: NUMBERS_ALLOWED,
                                  },
                                });
                              }
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.sapAccountId
                          }
                        />
                      </Stack>
                    </Stack>
                  )}
                  <Stack>
                    <h4 style={{ color: "#727272", marginBottom: "-5px" }}>
                      Contacts
                    </h4>
                  </Stack>
                  <Separator />
                  {(isShippingContactChecked ||
                    isShippingByBusinessContactChecked) &&
                  (!isShippingChecked ||
                    !isShippingByBusinessAddressChecked) ? (
                    <Stack style={{ color: "#727272" }}>
                      <h4 style={{ color: "black" }}>Contact</h4>
                      <p>{`${customerAccountInfo.shippingAddress.contacts.contactFirstName} ${customerAccountInfo.shippingAddress.contacts.contactLastName}`}</p>
                      <p>{`${customerAccountInfo?.shippingAddress.contacts.contactPhone}`}</p>
                      <p>{`${customerAccountInfo?.shippingAddress.contacts.contactEmail}`}</p>
                      {shippingContactsErrorMessages.length > 0 && (
                        <p
                          style={{ color: "red" }}
                        >{`Required Fields are missing`}</p>
                      )}
                    </Stack>
                  ) : (
                    <Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="First Name"
                          ariaLabel="First Name"
                          name="firstName"
                          required
                          value={
                            customerAccountInfo.shippingAddress?.contacts
                              ?.contactFirstName
                          }
                          onChange={(e, contactFirstNameValue) => {
                            if (
                              contactFirstNameValue &&
                              contactFirstNameValue?.length > 0
                            ) {
                              var characterCustomerContactFirstName =
                                allowSpecialCharacterExcludingSome.test(
                                  contactFirstNameValue
                                );
                              if (characterCustomerContactFirstName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactFirstName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactFirstName:
                                      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                contacts: {
                                  ...customerAccountInfo.shippingAddress
                                    .contacts,
                                  contactFirstName: contactFirstNameValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.shippingAddress?.contacts
                                ?.contactFirstName &&
                              customerAccountInfo.shippingAddress?.contacts
                                ?.contactFirstName?.length > 0
                            ) {
                              var characterCustomerContactFirstName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.shippingAddress?.contacts
                                    ?.contactFirstName
                                );
                              if (
                                customerAccountInfo.shippingAddress?.contacts
                                  ?.contactFirstName.length >
                                contactNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactFirstName:
                                        CONTACT_FIRSTNAME_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (characterCustomerContactFirstName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactFirstName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactFirstName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactFirstName:
                                      AUTHORIZED_BUYER_FIRSTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.contacts
                              .contactFirstName
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Last Name"
                          ariaLabel="Last Name"
                          name="lastName"
                          required
                          value={
                            customerAccountInfo.shippingAddress?.contacts
                              ?.contactLastName
                          }
                          onChange={(e, contactlastNameValue) => {
                            if (
                              contactlastNameValue &&
                              contactlastNameValue?.length > 0
                            ) {
                              var characterCustomerContactLastName =
                                allowSpecialCharacterExcludingSome.test(
                                  contactlastNameValue
                                );
                              if (characterCustomerContactLastName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactLastName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactLastName:
                                      AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                contacts: {
                                  ...customerAccountInfo.shippingAddress
                                    .contacts,
                                  contactLastName: contactlastNameValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.shippingAddress?.contacts
                                ?.contactLastName &&
                              customerAccountInfo.shippingAddress?.contacts
                                ?.contactLastName?.length > 0
                            ) {
                              var characterCustomerContactLastName =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.shippingAddress?.contacts
                                    ?.contactLastName
                                );
                              if (
                                customerAccountInfo.shippingAddress?.contacts
                                  ?.contactLastName.length >
                                contactNameCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactLastName:
                                        CONTACT_LASTNAME_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (characterCustomerContactLastName) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactLastName: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactLastName:
                                        CHARACTERS_SOME_SPECIAL_CHARACTER_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactLastName:
                                      AUTHORIZED_BUYER_LASTNAME_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.contacts
                              .contactLastName
                          }
                        />
                      </Stack>
                      <Stack horizontal tokens={{ childrenGap: 30 }}>
                        <TextField
                          styles={TextFieldStyles}
                          label="Phone"
                          name="shippingPhone"
                          ariaLabel="Phone"
                          required
                          value={
                            customerAccountInfo.shippingAddress.contacts
                              .contactPhone
                          }
                          onChange={(e, contactPhoneValue) => {
                            if (
                              contactPhoneValue &&
                              contactPhoneValue?.length > 0
                            ) {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactPhone: "",
                                  },
                                },
                              });
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                            if (
                              contactPhoneValue &&
                              contactPhoneValue?.length > 0
                            ) {
                              var characterCustomerContactPhone =
                                contactNumberRegex.test(contactPhoneValue);
                              if (characterCustomerContactPhone) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactPhone: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                contacts: {
                                  ...customerAccountInfo.shippingAddress
                                    .contacts,
                                  contactPhone: contactPhoneValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.shippingAddress.contacts
                                .contactPhone &&
                              customerAccountInfo.shippingAddress.contacts
                                .contactPhone?.length > 0
                            ) {
                              var checkLength = phoneNumberRegex.test(
                                customerAccountInfo.shippingAddress.contacts
                                  .contactPhone
                              );
                              var characterCustomerContactPhone =
                                contactNumberRegex.test(
                                  customerAccountInfo?.shippingAddress?.contacts
                                    ?.contactPhone
                                );
                              if (characterCustomerContactPhone) {
                                if (!checkLength) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      contacts: {
                                        ...customerAccountError.shippingAddress
                                          .contacts,
                                        contactPhone: INVALID_PHONENUMBER,
                                      },
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      contacts: {
                                        ...customerAccountError.shippingAddress
                                          .contacts,
                                        contactPhone: "",
                                      },
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactPhone:
                                        SPECIL_CHARACTER_INVALID_PHONENUMBER,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactPhone:
                                      AUTHORIZED_BUYER_PHONE_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.contacts
                              .contactPhone
                          }
                        />
                        <TextField
                          styles={TextFieldStyles}
                          label="Email"
                          name="contactEmail"
                          ariaLabel="Email"
                          required
                          value={
                            customerAccountInfo.shippingAddress.contacts
                              .contactEmail
                          }
                          onChange={(e, contactEmailValue) => {
                            if (
                              contactEmailValue &&
                              contactEmailValue?.length > 0
                            ) {
                              var characterCustomerAuthorizedEmailId =
                                allowSpecialCharacterExcludingSome.test(
                                  contactEmailValue
                                );
                              if (characterCustomerAuthorizedEmailId) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactEmail: "",
                                    },
                                  },
                                });
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactEmail:
                                        SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactEmail:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  },
                                },
                              });
                            }
                            setCustomerAccountInfo({
                              ...customerAccountInfo,
                              shippingAddress: {
                                ...customerAccountInfo.shippingAddress,
                                contacts: {
                                  ...customerAccountInfo.shippingAddress
                                    .contacts,
                                  contactEmail: contactEmailValue || "",
                                },
                              },
                            });
                          }}
                          onBlur={() => {
                            if (
                              customerAccountInfo.shippingAddress.contacts
                                .contactEmail &&
                              customerAccountInfo.shippingAddress.contacts
                                .contactEmail?.length > 0
                            ) {
                              var emailCustomerAuthorizedEmailId =
                                allowSpecialCharacterExcludingSome.test(
                                  customerAccountInfo.shippingAddress.contacts
                                    .contactEmail
                                );
                              var characterCustomerAuthorizedEmailId =
                                emailRegex.test(
                                  customerAccountInfo.shippingAddress.contacts
                                    .contactEmail
                                );
                              if (
                                customerAccountInfo.shippingAddress.contacts
                                  .contactEmail.length > emailCharacterLimit
                              ) {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactEmail: EMAIL_CHARACTER_LIMIT,
                                    },
                                  },
                                });
                              } else if (emailCustomerAuthorizedEmailId) {
                                if (characterCustomerAuthorizedEmailId) {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      contacts: {
                                        ...customerAccountError.shippingAddress
                                          .contacts,
                                        contactEmail: "",
                                      },
                                    },
                                  });
                                } else {
                                  setCustomerAccountError({
                                    ...customerAccountError,
                                    shippingAddress: {
                                      ...customerAccountError.shippingAddress,
                                      contacts: {
                                        ...customerAccountError.shippingAddress
                                          .contacts,
                                        contactEmail: EMAIL_VALIDATION,
                                      },
                                    },
                                  });
                                }
                              } else {
                                setCustomerAccountError({
                                  ...customerAccountError,
                                  shippingAddress: {
                                    ...customerAccountError.shippingAddress,
                                    contacts: {
                                      ...customerAccountError.shippingAddress
                                        .contacts,
                                      contactEmail:
                                        SOME_SPECIAL_CHARACTERS_NOT_ALLOWED,
                                    },
                                  },
                                });
                              }
                            } else {
                              setCustomerAccountError({
                                ...customerAccountError,
                                shippingAddress: {
                                  ...customerAccountError.shippingAddress,
                                  contacts: {
                                    ...customerAccountError.shippingAddress
                                      .contacts,
                                    contactEmail:
                                      AUTHORIZED_BUYER_EMAIL_REQUIRED,
                                  },
                                },
                              });
                            }
                          }}
                          errorMessage={
                            customerAccountError.shippingAddress.contacts
                              .contactEmail
                          }
                        />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              )}
            </Card>
          </Stack>
          <Stack style={{ marginLeft: "330px" }} horizontal>
            <PrimaryButton
              text="Create & Next"
              type="button"
              disabled={isSaveButtonDisabled || taxIdExist || !msxIdExist}
              onClick={handleAddCustomerClick}
              style={SaveAndNextButtonStyleShipping}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  ) : (
    <Stack></Stack>
  );
};
